document.addEventListener('DOMContentLoaded', function() {

 window.currentTiffinPlan = 1;
  window.tempCartStore = [];
  let CartupdateReviewIntial 
  let showToaster = true;
  let soldout_nextweekmenu_enable = false;
    let uniqueDay 
    // let SelectedDay 

  const isMobile = window.innerWidth < 768;

  // day/calendar at header starts from here
const weekContainer = document.getElementById('weekContainer');
const weekRange = document.getElementById('weekRange');
    const now = getCaliforniaTime();

const today = now;
let selectedDate = new Date(today);
let SelectedDay = today.toLocaleDateString('en-GB', { weekday: 'long' }).toLowerCase();

const monday = getMonday(today);
const friday = new Date(monday);
friday.setDate(monday.getDate() + 4);

renderWeek(monday);

  // Day → index map
  const weekdayIndexMapX = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
  };

  // Load cutoff settings
  const cutoffConfigX = window.menuCutOffData || {};
  const fridayConfigX = cutoffConfigX.friday || {};

  // Hour after which Friday flips
  const cutoffHourX = Number.isFinite(Number(fridayConfigX.nexdaymenushowTime))
    ? Number(fridayConfigX.nexdaymenushowTime)
    : 11;

  // Whether Friday logic is enabled
  const enableFridayShiftX =
    fridayConfigX.nextdaymenuShow === true ||
    Object.prototype.hasOwnProperty.call(fridayConfigX, "nexdaymenushowTime");

  // ---- Time Helper: Get California Time ----
  function getPacificNowX() {
    const localStrX = new Date().toLocaleString("en-US", {
      timeZone: "America/Los_Angeles",
    });
    return new Date(localStrX);
  }

  const nowX = getPacificNowX();
  const todayIndexX = nowX.getDay();
  const hourNowX = nowX.getHours();




  // ---- Compute date for a given day index ----
  function computeNextDateX(targetIndexX) {
    let diffX = (targetIndexX - todayIndexX + 7) % 7;
    if (targetIndexX === 5) {
      const isPastCutoffX = todayIndexX === 5 && hourNowX >= cutoffHourX;
      const isWeekendX = todayIndexX === 6 || todayIndexX === 0;
      if ((enableFridayShiftX && isPastCutoffX) || isWeekendX) {
        if (diffX === 0) diffX = 7;
      }
    }
    const finalDateX = new Date(nowX);
    finalDateX.setDate(nowX.getDate() + diffX);
    const yyyyX = finalDateX.getFullYear();
    const mmX = String(finalDateX.getMonth() + 1).padStart(2, "0");
    const ddX = String(finalDateX.getDate()).padStart(2, "0");
    return `${yyyyX}/${mmX}/${ddX}`;
  }

  // Apply dates to calendar UI
  document.querySelectorAll(".tiffin-calendar-day-btn").forEach((labelX) => {
    const dayNameX = labelX.dataset.dayName; // Example: "monday"
    labelX.setAttribute('data-date', computeNextDateX(weekdayIndexMapX[dayNameX]))
  });



function updateNavButtons() {
  const days = Array.from(document.querySelectorAll('.tiffin-calendar-day-btn'));
  const activeIndex = days.findIndex(btn => btn.classList.contains('active-day'));
  const prevBtn = document.querySelector('.tiffin-prev-tiffin-day');
  const nextBtn = document.querySelector('.next-tiffin-day');
  if(!days && !prevBtn && !nextBtn) return;
  const prevAvailable = days
    .slice(0, activeIndex)
    .reverse()
    .find(btn => !btn.classList.contains('not-available') && window.getComputedStyle(btn).display !== 'none');

  const nextAvailable = days
    .slice(activeIndex + 1)
    .find(btn => !btn.classList.contains('not-available') && window.getComputedStyle(btn).display !== 'none');

 if(prevBtn) prevBtn.disabled = !prevAvailable;
 if(nextBtn) nextBtn.disabled = !nextAvailable;
}



function activateNextDay() {
  const days = Array.from(document.querySelectorAll('.tiffin-calendar-day-btn'));
  let activeIndex = days.findIndex(btn => btn.classList.contains('active-day'));

  const nextAvailable = days
    .slice(activeIndex + 1)
    .find(btn => !btn.classList.contains('not-available') && window.getComputedStyle(btn).display !== 'none');

  if (nextAvailable) {
    days[activeIndex].classList.remove('active-day');
    nextAvailable.classList.add('active-day');
    nextAvailable.click()
    updateNavButtons();
  }
}



function activatePrevDay() {
  const days = Array.from(document.querySelectorAll('.tiffin-calendar-day-btn'));
  let activeIndex = days.findIndex(btn => btn.classList.contains('active-day'));

  const prevAvailable = days
    .slice(0, activeIndex)
    .reverse()
    .find(btn => !btn.classList.contains('not-available') && window.getComputedStyle(btn).display !== 'none');

  if (prevAvailable) {
    days[activeIndex].classList.remove('active-day');
    prevAvailable.classList.add('active-day');
    prevAvailable.click()
    updateNavButtons();
  }
}





function getVisibleButtons() { 
  const allButtons = document.querySelectorAll('.tiffin-calendar-day-btn');
  const availableButtons = Array.from(allButtons).filter(
    btn => !btn.classList.contains('not-available')
  );
  return availableButtons;
}


function getWeekRange() {
  const allButtons = document.querySelectorAll('.tiffin-calendar-day-btn');
 const visibleButtons = getVisibleButtons()
  if (visibleButtons.length === 0) return '';
  const dates = visibleButtons.map(btn => new Date(btn.dataset.date));
  const minDate = new Date(Math.min(...dates));
  const maxDate = new Date(Math.max(...dates));
  console.log('min date checking',minDate)

  const monthNames = [
    'January','February','March','April','May','June',
    'July','August','September','October','November','December'
  ];

  const sameDay = minDate.getDate() === maxDate.getDate();
  if (sameDay) {
    return `${minDate.getDate()}th ${monthNames[minDate.getMonth()]}`;
  }
  return `${minDate.getDate()}th ${monthNames[minDate.getMonth()]} - ${maxDate.getDate()}th ${monthNames[maxDate.getMonth()]}`;
}



  const all_products_wrapper = document.querySelector(".order-tiffin-main-container");
   const soldoutmsg = document.querySelector('.soldout-msg');
  const dayButtons = document.querySelectorAll(".tiffin-calendar-day-btn");
  const global_filter_tagsAll = document.querySelectorAll('.global-filter-value');
  const clear_filter_tag = document.querySelector('.clear-filter-tag');


setupDaysAndPackaging()

// Event bindings
const nextBtn = document.querySelector('.next-tiffin-day');
const prevBtn = document.querySelector('.tiffin-prev-tiffin-day');
if (nextBtn) nextBtn.addEventListener('click', activateNextDay);
if (prevBtn) prevBtn.addEventListener('click', activatePrevDay);

// Initialize state
updateNavButtons();




function getMonday(d) {
  const date = new Date(d);
  const day = date.getDay();
  const diff = date.getDate() - day + (day === 0 ? -6 : 1);
  return new Date(date.setDate(diff));
}

function renderWeek(monday) {
  if(weekContainer){
  weekContainer.innerHTML = '';
  const friday = new Date(monday);
  friday.setDate(monday.getDate() + 4);


  for (let i = 0; i < 5; i++) {
    const day = new Date(monday);
    day.setDate(monday.getDate() + i);
    console.log('monday checking',monday)
    console.log('final day checking',day)

    const btn = document.createElement('button');
    btn.className = 'tiffin-calendar-day-btn';
    btn.dataset.dayName = day.toLocaleDateString('en-GB', { weekday: 'long' }).toLowerCase();
    btn.innerHTML = `
      <strong>${day.toLocaleDateString('en-GB', { weekday: 'short' }).toUpperCase()}</strong>
      <span></span>
    `;
    weekContainer.appendChild(btn);
  }
 }
  
}



function updateActiveDay() {
  document.querySelectorAll('.tiffin-calendar-day-btn').forEach(d => d.classList.remove('active-day'));
  const active = [...document.querySelectorAll('.tiffin-calendar-day-btn')].find(
    d => d.dataset.dayName === SelectedDay
  );
  if (active) { 
    active.classList.add('active-day');
    active.click()
  } 
}

function updateButtons() {
  const prevBtn = document.getElementById('prevDay');
  const nextBtn = document.getElementById('nextDay');
  prevBtn.disabled = selectedDate <= today || selectedDate <= monday;
  nextBtn.disabled = selectedDate >= friday;
}


// add the correct date on buttons and product sections start from here
   const dayMap = { sunday: 0, monday: 1, tuesday: 2, wednesday: 3, thursday: 4, friday: 5, saturday: 6 };
    const menuData = window.menuCutOffData || {};
    const fridayData = menuData.friday || {};
    // Use the time if provided (default 11), and treat its presence as enabling the flip
    const cutoffHour = Number.isFinite(Number(fridayData.nexdaymenushowTime))
      ? Number(fridayData.nexdaymenushowTime)
      : 11;

    const flipAfterCutoff = fridayData.nextdaymenuShow === true || Object.prototype.hasOwnProperty.call(fridayData, 'nexdaymenushowTime');
    // --- Store time (California) ---
    function getCaliforniaTime() {
      const s = new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
      return new Date(s);
    }
    const todayWday = now.getDay(); // 0..6
    const currentHour = now.getHours(); // 0..23


function getTargetDayDAte(targetWday) {
  let offset = (targetWday - todayWday + 7) % 7;
  if (targetWday === 5) {
    const isPastFridayCutoff = todayWday === 5 && currentHour >= cutoffHour;
    const isWeekend = todayWday === 6 || todayWday === 0;
    if ((flipAfterCutoff && isPastFridayCutoff) || isWeekend) {
      if (offset === 0) offset = 7;
    }
  }

  const d = new Date(now);
  d.setDate(now.getDate() + offset);
  return d.getDate(); // ← only the day number, e.g. 4 or 5
}

    function getTargetDate(targetWday) {
      // base: next occurrence (this week or next)
      let offset = (targetWday - todayWday + 7) % 7;
      if (targetWday === 5) {
        // Friday button
        const isPastFridayCutoff = todayWday === 5 && currentHour >= cutoffHour;
        const isWeekend = todayWday === 6 || todayWday === 0; // Sat/Sun
        // Rule:
        // - Friday after cutoff -> next Friday
        // - Saturday/Sunday -> always next Friday
        if ((flipAfterCutoff && isPastFridayCutoff) || isWeekend) {
          if (offset === 0) offset = 7; // if pointing to "this" Friday, push a week
          // (On Sat/Sun, base offset is already 6/5 which is next Friday, so no change)
        }
      }
      const d = new Date(now);
      d.setDate(now.getDate() + offset);
      return `${d.getMonth() + 1}/${d.getDate()}`;
    }

    document.querySelectorAll('.tiffin-calendar-day-btn').forEach((el) => {
      const dayName = el.dataset.dayName; // expects "Monday", "Tuesday", ...
      const daytextelment = el.querySelector('span')
      daytextelment.textContent = getTargetDayDAte(dayMap[dayName]);
    });
    // Update buttons
    document.querySelectorAll('.tiffinday-quantity-addtocartbtn').forEach((el) => {
      const dayName = el.dataset.dayName; // expects "Monday", ...
      el.setAttribute('data-day-date', getTargetDate(dayMap[dayName]));
    });

    document.querySelectorAll('.maintiffin-products-select').forEach((el) => {
      const dayName = el.dataset.dayName; // expects "Monday", ...
      el.setAttribute('data-day-date', getTargetDate(dayMap[dayName]));
    });
// /add the correct date on buttons and product sections ends here









 
  
function setupDaysAndPackaging() {
      const tagfiltercontainer = document.querySelector('.filter-tag-container');
      const sidebarcontainer = document.querySelector('.order-tiffin-sdiebar');
      const gotonextday = document.querySelector('.tiffin-goto-nextday-btn')
    const menuData = window.menuCutOffData;
    if (menuData) {
         const next_weekmenu_msg = document.querySelector(".new-menu-comming-soon-msg")

        const daysMap = [
            "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"
        ];
        const laDate = new Date().toLocaleString("en-US", {
            timeZone: "America/Los_Angeles",
        });
        const now = new Date(laDate);
        const currentHour = now.getHours();
        let todayIdx = now.getDay();


        // let todayIdx = 1;
        // const currentHour = 10

        const currentMinute = now.getMinutes();
        const shownexMenuData = menuData['friday']
        const disableMenu = shownexMenuData.nextdaymenuShow;
        const showUpcomingMenuTime = shownexMenuData.nexdaymenushowTime;



        let todayName = daysMap[todayIdx];
        let todayData = menuData[todayName];
        let showDayIdx = null;
        let showSoldOut = false;
        let shownextmenutext = false
        let fridayMenuShow = false
        let fridaymenu = false
        let fridayMenuSoldOutMsgshow = false
        let fridaylessthan12 = false
        let fridaygreatthan12 = false
        let nextmenumonday = false


        // Case 1: If it's before cut-off today
        if ((currentHour < todayData?.cutOff) && todayIdx != 5) {
            if (todayData.disable) {
                showDayIdx = todayIdx;
                showSoldOut = true;
            } else {
                // Today is available
                showDayIdx = todayIdx;
                showSoldOut = false;
            }
        } else if (todayIdx == 6 || todayIdx == 0) {
            showDayIdx = 1;
        } else if (todayIdx == 5 && currentHour >= showUpcomingMenuTime && !disableMenu) {
            showDayIdx = 1;
            shownextmenutext = false;
            fridaygreatthan12 = true;
            nextmenumonday = true
            fridaymenu = false
        } else if (todayIdx == 5 && currentHour >= showUpcomingMenuTime && disableMenu) {
            shownextmenutext = true;
            fridaygreatthan12 = true;
            showDayIdx = 5;
            fridaymenu = true

        } else if (todayIdx == 5 && currentHour < showUpcomingMenuTime) {
            fridaylessthan12 = true
            showDayIdx = 5;
            if (currentHour < todayData.cutOff) {
                if (todayData.disable) {
                    showDayIdx = todayIdx;
                    fridayMenuShow = false;
                    fridaymenu = true;
                    fridayMenuSoldOutMsgshow = false

                } else {
                    // Today is available
                    showDayIdx = todayIdx;
                    fridayMenuShow = true;
                    fridaymenu = true;
                    fridayMenuSoldOutMsgshow = false
                }
            } else {
                shownextmenutext = true;
                fridaymenu = true;
                fridayMenuSoldOutMsgshow = true
            }
        } else {
            let idx = (todayIdx + 1) % 7;
            showDayIdx = idx;
            // If none found, default to Monday 
            if (showDayIdx === null) showDayIdx = 1;
        }
       




        // Hide/show UI based on result
        dayButtons.forEach((button) => {
            const dayRaw = button.getAttribute("data-day-name");
            const day = dayRaw.toLowerCase()
            const dayIndex = daysMap.indexOf(day);
            const dayWrapper = document.querySelector(`.tiffin-products-${day}-wrapper`);
            const daysoldoutmsg = document.querySelector(`.daywise-soldout-mgs[data-daywise-category='${day}']`)
            const laDate = new Date().toLocaleString("en-US", {
                timeZone: "America/Los_Angeles",
            });
            const isPastDay = dayIndex < showDayIdx;
            if ((dayIndex === showDayIdx) && !fridaymenu) {
                button.style.display = "inline-block";
                button.classList.add("active-day");
                SelectedDay = day
                button.removeAttribute("disabled");
                // if (dayWrapper) dayWrapper.style.display = "block";
                if (showSoldOut) {
                  soldout_nextweekmenu_enable = true
                  console.log('from here 1')
                    if (daysoldoutmsg) daysoldoutmsg.style.display = "block";
                    if(tagfiltercontainer) tagfiltercontainer.style.display='none'
                    if(sidebarcontainer) sidebarcontainer.style.display='none'
                    if (dayWrapper) dayWrapper.style.display = "none";
                    if(gotonextday) gotonextday.style.display='none'
                    console.log('day wrapper checking',dayWrapper)
                    button.classList.add('soldout')
                } else {
                    console.log('from here 2')
                    if (daysoldoutmsg) daysoldoutmsg.style.display = "none";
                    if(tagfiltercontainer) tagfiltercontainer.style.display='flex'
                    if(sidebarcontainer) sidebarcontainer.style.display='block'
                      if(gotonextday) gotonextday.style.display='block'
                    if (dayWrapper) { 
                      dayWrapper.style.display = "block";
                    } 
                }
            } else if (isPastDay) {
                button.style.display = "none";
                button.classList.add('not-available')
                button.classList.remove("active-day");
                if (dayWrapper) dayWrapper.style.display = "none";
            } else if ((dayIndex < showDayIdx) && todayIdx != 5) {
                button.style.display = "none";
                button.classList.add('not-available')
                button.classList.remove("active-day");
                if (dayWrapper) dayWrapper.style.display = "none";
            }

            // when current hour is less than threshold
            else if ((fridaymenu && fridaylessthan12) && (todayIdx == 5 && dayIndex == 5)) {
                if (fridayMenuShow) {
                    button.classList.add("active-day");
                     SelectedDay = day
                    if (all_products_wrapper) all_products_wrapper.style.display = "block";
                    next_weekmenu_msg.style.display = 'none'
                    if (dayWrapper) dayWrapper.style.display = "block";
                } else {
                    button.classList.add("active-day");
                    SelectedDay = day
                    if (all_products_wrapper) all_products_wrapper.style.display = "none";
                    if (fridayMenuSoldOutMsgshow) {
                        next_weekmenu_msg.style.display = 'block'
                        soldout_nextweekmenu_enable = true
                    } else {
                        soldoutmsg.style.display = 'block'
                       soldout_nextweekmenu_enable = true
                        button.classList.add('soldout')
                    }

                }
            } else if ((fridaygreatthan12 && shownextmenutext) && (todayIdx == 5 && dayIndex == 5)) //upcoming menu
            {
                const next_weekmenu_msg = document.querySelector(".new-menu-comming-soon-msg");
                if (!shownextmenutext) {
                    if (all_products_wrapper) all_products_wrapper.style.display = "block";
                    next_weekmenu_msg.style.display = 'none'
                } else {
                    if (all_products_wrapper) all_products_wrapper.style.display = "none";
                    next_weekmenu_msg.style.display = 'block'
                    soldout_nextweekmenu_enable = true
                }
            }
            //  if (button.classList.contains("active-day")) {
            //    const selectedDay= button.getAttribute("data-day-name");
            //    SelectedDay = day
            //  const tiffin_type_selection_wrapper = document.querySelector(`.tiffin-products-daywise-wrapper[data-daywise-category='${selectedDay.toLowerCase()}']`);
            //   tiffin_type_selection_wrapper.style.display ='block'
            //  }
           
        });

       const weekrangetext = getWeekRange()
      weekRange.textContent = weekrangetext;

      const activeDaySelected = document.querySelector('.tiffin-calendar-day-btn.active-day');
      const activeday_name = activeDaySelected?.getAttribute("data-day-name");
      const goto_nextday_button = document.querySelector('.tiffin-goto-nextday-btn');
      if (activeday_name && goto_nextday_button) {

  // compare the lowercase day name
    if (activeday_name.toLowerCase() === 'friday') {
      goto_nextday_button.classList.add('hidden');
    } else {
     goto_nextday_button.classList.remove('hidden');
    }

}


    }
}
  



dayButtons.forEach((button) => {
    button.addEventListener("click", function () {
       const selectedDay= button.getAttribute("data-day-name");
       selectNonExistingPlan(selectedDay)
      const mainTiffinWrapper = document.querySelector(
      `.main-tiff-type-prod-selector[data-products-day="${selectedDay}"]`
    );
    const tagfiltercontainer = document.querySelector('.filter-tag-container')
          const sidebarcontainer = document.querySelector('.order-tiffin-sdiebar')
    const alacarteWrapper = document.querySelector(
      `.alacarte-tiff-type-prod-selector[data-products-day="${selectedDay}"]`
    );
     if(tagfiltercontainer) tagfiltercontainer.style.display='flex'
                    if(sidebarcontainer) sidebarcontainer.style.display='block'
    const goto_nextday_button = document.querySelector('.tiffin-goto-nextday-btn')
    const daywise_product_wrapper = document.querySelector(`.tiffin-products-${selectedDay}-wrapper`)
    const maintffin_sidebar_categories = document.querySelector('.main-tiffin-side-cat-select')
    const alacartetffin_sidebar_categories = document.querySelector('.alacarte-tiffin-side-cat-select')
      // currentActiveDay = selectedDay;
        soldoutmsg.style.display='none'
       all_products_wrapper.style.display = 'block'
      // Hide all day sections and remove active class from all buttons
        const all_daywise_wrappers = document.querySelectorAll(`.tiffin-products-daywise-wrapper`)
        all_daywise_wrappers.forEach(daywisewrapper => {
        daywisewrapper.style.display = 'none'
        });

        const all_daywise_soldoutmsg = document.querySelectorAll(`.daywise-soldout-mgs`)
        all_daywise_soldoutmsg.forEach(soldoutmsgday => {
        soldoutmsgday.style.display = 'none'
        });

      dayButtons.forEach((btn) => {
        const btnDay= button.getAttribute("data-day-name");
        btn.classList.remove("active-day");
      const clicked_day_wise_wrapper= document.querySelector(`.tiffin-products-${selectedDay}-wrapper`);
      const clicked_button = document.querySelector(`.tiffin-calendar-day-btn[data-day-name=${selectedDay}]`)
       clicked_button.classList.add('active-day')
       SelectedDay = selectedDay;
       clicked_day_wise_wrapper.style.display ='block'
      });

      if(button.classList.contains('soldout'))
      { 
              const clicked_day_wise_wrapper= document.querySelector(`.tiffin-products-${selectedDay}-wrapper`);
                          const daysoldoutmsg = document.querySelector(`.daywise-soldout-mgs[data-daywise-category='${selectedDay}']`)
 if(tagfiltercontainer) tagfiltercontainer.style.display='none'
                    if(sidebarcontainer) sidebarcontainer.style.display='none'
          clicked_day_wise_wrapper.style.display = "none";
        daysoldoutmsg.style.display='block'
          this.classList.add("active-day");
           SelectedDay = selectedDay;
          return;
      }
     document.querySelectorAll('.order-tiffin-type-btn').forEach(d => d.classList.remove('active'));
     const maintiffintypebutton = document.querySelector('.main-tiffin-type-btn');
      mainTiffinWrapper.style.display='block'
      maintffin_sidebar_categories.style.display='block'
      document.querySelectorAll('.alacarte-tiffin-side-cat-select').forEach(element => {
          element.style.display='none'
        });
      alacarteWrapper.style.display='none'
      alacartetffin_sidebar_categories.style.display='none'
      maintiffintypebutton.classList.add('active')

 
        const tiffintypebutton = document.querySelector(`.main-tiffin-type-btn[data-day-name=${selectedDay}]`)
          const alamianbutton = document.querySelector(`.alacarte-tiffin-type-btn[data-day-name=${selectedDay}]`)
        if(tiffintypebutton && alamianbutton){ 
          tiffintypebutton.classList.add('active')
          alamianbutton.classList.remove('active')
          alamianbutton.style.display = 'block'

        }
        if(selectedDay == 'friday')
        { 
           if(goto_nextday_button) goto_nextday_button.classList.add('hidden')
        } else { 
         if(goto_nextday_button) goto_nextday_button.classList.remove('hidden')
      }
    });
  });




 const ordertiffin_typebuttons =  document.querySelectorAll('.order-tiffin-type-btn')
 if(ordertiffin_typebuttons.length > 0){
  ordertiffin_typebuttons[0].classList.add('active');
 ordertiffin_typebuttons.forEach(button => {
  button.addEventListener('click', function() {
    const selectedDay = this.getAttribute('data-day-name');
    const value = this.getAttribute('data-value');
    const siblings = this.parentElement.querySelectorAll('.order-tiffin-type-btn');
    siblings.forEach(btn => btn.classList.remove('active'));
    this.classList.add('active');
    const mainWrapper = document.querySelector(
      `.main-tiff-type-prod-selector[data-products-day="${SelectedDay}"]`
    );
    const alacarteWrapper = document.querySelector(
      `.alacarte-tiff-type-prod-selector[data-products-day="${SelectedDay}"]`
    );
    const maintffin_sidebar_categories = document.querySelector('.main-tiffin-side-cat-select')
    const alacartetffin_sidebar_categories = document.querySelector('.alacarte-tiffin-side-cat-select')

    if (value == 'main') {
      document.querySelectorAll('.alacarte-tiffin-side-cat-select').forEach(element => {
          element.style.display='none'
        });
      if (mainWrapper) mainWrapper.style.display = 'block';
       if (maintffin_sidebar_categories) maintffin_sidebar_categories.style.display = 'block';
      if (alacarteWrapper) alacarteWrapper.style.display = 'none';
      if (alacartetffin_sidebar_categories) alacartetffin_sidebar_categories.style.display = 'none';
      removeFilterTags()

       } 
       else if (value == 'alacarte') {
        document.querySelectorAll('.alacarte-tiffin-side-cat-select').forEach(element => {
          element.style.display='none'
        });
        const alacarte_daysidebar = document.querySelector(`.alacarte-sidebar-${SelectedDay}-wrapper`)
        alacarte_daysidebar.style.display = 'block'
        const alacarte_sidebarlist = alacarte_daysidebar.querySelectorAll('.sidebar-cat-name-alacarte')
        alacarte_sidebarlist[0].classList.add('active')

      if (mainWrapper) mainWrapper.style.display = 'none';
      if (maintffin_sidebar_categories) maintffin_sidebar_categories.style.display = 'none';

      if (alacarteWrapper) alacarteWrapper.style.display = 'block';
      // if (alacartetffin_sidebar_categories) alacartetffin_sidebar_categories.style.display = 'block';
      removeFilterTags()

    }
    closePopup()
    reversSelectedmainTiffinlayout()
  });
});
 }


// accordian
  // document.addEventListener("click", function (e) {
  //   const tiffinday_category_title = e.target.closest(
  //     ".tiffinday-selected-item-headers"
  //   );
  //   if (tiffinday_category_title) {
  //     const cat_title =
  //       tiffinday_category_title.getAttribute("data-tiffin-cat");
  //     const tiffinday_mainwrapper = tiffinday_category_title.closest(
  //       ".tiffin-prods-and-title-wrapper"
  //     );
  //     console.log('tiffin day main wrapper',tiffinday_mainwrapper)
  //     const productlist = tiffinday_mainwrapper.querySelector(
  //       `.category-prdlist-wrapper[data-tiffin-cat="${cat_title}"]`
  //     );
  //     productlist.classList.toggle("hidden");
  //     tiffinday_category_title.classList.toggle("accord-active");
  //   }
  // });


// sidebar category selection
const maintiffin_sidebar_categoryAll = document.querySelectorAll('.sidebar-cat-name-maintiffin');

if (maintiffin_sidebar_categoryAll.length > 0) { 
 maintiffin_sidebar_categoryAll[0].classList.add('active');
  maintiffin_sidebar_categoryAll.forEach(maintiffin_category => {
    maintiffin_category.addEventListener('click', function() { 
      const selected_sidebar_catname = maintiffin_category.dataset.catName;
        document.querySelectorAll('.sidebar-cat-name-maintiffin').forEach(d => d.classList.remove('active'));
        maintiffin_category.classList.add('active')

      const goto_maintiffin_wrapper = document.querySelector(
        `.main-tiff-type-prod-and-title-wrapper[data-tiffin-cat='${selected_sidebar_catname}'][data-tiffin-day='${SelectedDay}']`
      );
        if (goto_maintiffin_wrapper) {
        goto_maintiffin_wrapper.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
}



const alacartetiffin_sidebar_categoryAll = document.querySelectorAll('.sidebar-cat-name-alacarte');

if (alacartetiffin_sidebar_categoryAll.length > 0) { 
 alacartetiffin_sidebar_categoryAll[0].classList.add('active');
  alacartetiffin_sidebar_categoryAll.forEach(alacartetiffin_category => {
    alacartetiffin_category.addEventListener('click', function() { 
      const selected_sidebar_catname = alacartetiffin_category.dataset.catName;
       document.querySelectorAll('.sidebar-cat-name-alacarte').forEach(d => d.classList.remove('active'));
           alacartetiffin_category.classList.add('active')

      const goto_alacartetiffin_wrapper = document.querySelector(
        `.alacarte-tiff-type-prod-and-title-wrapper[data-tiffin-cat='${selected_sidebar_catname}'][data-tiffin-day='${SelectedDay}']`
      );
        if (goto_alacartetiffin_wrapper) {
        goto_alacartetiffin_wrapper.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
}


// product click popup handler
const productli_wrapper_clickable = document.querySelectorAll('.icon-hoveer-description');

if (productli_wrapper_clickable.length > 0) {
  productli_wrapper_clickable.forEach(prod_wrapper_li => {
    prod_wrapper_li.addEventListener('click', function (e) {
      e.preventDefault()
       document.querySelectorAll('.cart-summary-popover-info').forEach(d => d.style.display='none');
       const closest_li_element = prod_wrapper_li.closest('.maintiffin-category-product-li')
      const placeholderforpopupdata = closest_li_element.querySelector('.placholder-for-popup-data');
      const desktoppopupholder = document.querySelector('.desktop-product-popup-holder');
      const mobilepopupholder = document.querySelector('.mobile-product-popup-holder');
      const cartsummarycontainer = document.querySelector('.cart-summary-container ')

      if (placeholderforpopupdata) {
        const placholderhtml = placeholderforpopupdata.innerHTML.trim();

        if (desktoppopupholder) {
          desktoppopupholder.innerHTML = placholderhtml;
          desktoppopupholder.style.display = 'block';
                    console.log('is mobielchecing',isMobile)

          if(isMobile){ 
                document.body.classList.add('mobile-cart-summary')
                 document.body.classList.add('popup-description')
          if(cartsummarycontainer) cartsummarycontainer.classList.add('cart-summary-swipe')
          }
      
        }

        if (mobilepopupholder) {
          mobilepopupholder.innerHTML = placholderhtml;
          mobilepopupholder.style.display = 'block';
        }
      }
    });
  });
}

// product click popup handler
const productli_wrapper_clickable_alacarte = document.querySelectorAll('.alacarte-prod-img');

if (productli_wrapper_clickable_alacarte.length > 0) {
  productli_wrapper_clickable_alacarte.forEach(prod_wrapper_li => {
    prod_wrapper_li.addEventListener('click', function (e) {
       e.preventDefault()
       document.querySelectorAll('.cart-summary-popover-info').forEach(d => d.style.display='none');
      const placeholderforpopupdata = prod_wrapper_li.querySelector('.placholder-for-popup-data');
      const desktoppopupholder = document.querySelector('.desktop-product-popup-holder');
      const mobilepopupholder = document.querySelector('.mobile-product-popup-holder');
            const cartsummarycontainer = document.querySelector('.cart-summary-container ')


      if (placeholderforpopupdata) {
        const placholderhtml = placeholderforpopupdata.innerHTML.trim();

        if (desktoppopupholder) {
          desktoppopupholder.innerHTML = placholderhtml;
          desktoppopupholder.style.display = 'block';
          console.log('is mobielchecing',isMobile)
          if(isMobile){ 
                document.body.classList.add('mobile-cart-summary')
                document.body.classList.add('popup-description')
          if(cartsummarycontainer) cartsummarycontainer.classList.add('cart-summary-swipe')
          }
        }

        if (mobilepopupholder) {
          mobilepopupholder.innerHTML = placholderhtml;
          mobilepopupholder.style.display = 'block';
        }
      }
    });
  });
}


function closePopup()
{ 
document.querySelectorAll('.cart-summary-popover-info').forEach(d => d.style.display='block');
   const desktoppopupholder = document.querySelector('.desktop-product-popup-holder');
  desktoppopupholder.innerHTML = '';
}

document.addEventListener('click',function(e){ 
  if(e.target.closest('.popupdata-close-icon'))
  { 
    closePopup()
  }
})



 document.addEventListener("click", (e) => {
  const btn = e.target.closest(".minus-quantity-remove");
  if (btn) {
    const mainquantitySelector = e.target.closest('.minus-quantity-selector-ala');
    removeItemFromlist(mainquantitySelector);
  }
});


// clear filter logic
if (clear_filter_tag) {
  clear_filter_tag.addEventListener('click', () => {
    removeFilterTags()
  });
}

function removeFilterTags()
{ 
  document.querySelectorAll('.category-product-detail').forEach(li => {
      li.style.display = 'block';
    });
    document.querySelectorAll('.tiffin-prods-and-title-wrapper').forEach(w => {
      w.style.display = '';
    });
    document.querySelectorAll('.no-items-message').forEach(m => (m.style.display = 'none'));
    clear_filter_tag.style.display = 'none';
    global_filter_tagsAll.forEach(el => el.classList.remove('active'));
  
  clear_filter_tag.style.display = 'none';

}

// filter logic
if (global_filter_tagsAll.length) {
  global_filter_tagsAll.forEach(tag => {
    tag.addEventListener('click', () => {
      global_filter_tagsAll.forEach(el => el.classList.remove('active'));
      tag.classList.add('active');
      if (clear_filter_tag) clear_filter_tag.style.display = 'block';

      const clicked = tag.getAttribute('data-value')?.toLowerCase();

      // show/hide products by tag
      document.querySelectorAll('.category-product-detail').forEach(li => {
        const tags = (li.getAttribute('data-tags-list') || '')
          .toLowerCase()
          .split(',')
          .map(t => t.trim());
        li.style.display = !clicked || tags.includes(clicked) ? '' : 'none';
      });

      // hide wrappers with all children hidden
      document.querySelectorAll('.tiffin-prods-and-title-wrapper').forEach(wrapper => {
        const items = wrapper.querySelectorAll('.category-product-detail');
        const visible = Array.from(items).some(li => li.style.display !== 'none');
        wrapper.style.display = visible ? '' : 'none';
      });

      // check if all wrappers for the visible day are hidden
      const selectedDay = document
        .querySelector('.tiffin-products-daywise-wrapper[style*="display: block"]')
        ?.getAttribute('data-daywise-category');

      if (selectedDay) {
        const wrappersForDay = document.querySelectorAll(
          `.tiffin-prods-and-title-wrapper[data-tiffin-day="${selectedDay}"]`
        );
        const allHidden = Array.from(wrappersForDay).every(w => w.style.display === 'none');

        let msg = document.querySelector(
          `.tiffin-products-daywise-wrapper[data-daywise-category="${selectedDay}"] .no-items-message`
        );
        if (!msg) {
          msg = document.createElement('div');
          msg.className = 'no-items-message';
          msg.textContent = 'No items available';
          msg.style.textAlign = 'center';
          msg.style.padding = '1em';
          msg.style.display = 'none';
          const parent = document.querySelector(
            `.tiffin-products-daywise-wrapper[data-daywise-category="${selectedDay}"]`
          );
          if (parent) parent.appendChild(msg);
        }

        msg.style.display = allHidden ? 'block' : 'none';
      }
    });
  });
}


function scrollToTop()
{ 
   const selectionWrap = document.querySelector(".order-tiffin-product-wrapper");
       if (selectionWrap) {
      const elementTop = selectionWrap.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ 
         top: elementTop - 200, 
         behavior: "smooth" 
        });
       }
}

// show bottom buttons on scroll
window.addEventListener('scroll', () => {
  const btn = document.querySelector('.tiffin-bottom-ctas-button');
  if (!btn) return;
  if (window.scrollY > 100) {
    btn.classList.add('bottom-btn-visible');
  } else {
    btn.classList.remove('bottom-btn-visible');
  }
});


// Function to update the data-category-index of elements with the 'day' attribute
function updateCategoryIndexForDay(day, newIndex) {
  // Select all elements with the class 'tiffinday-selected-items-title'
  const items = document.querySelectorAll('.tiffinday-selected-items-title');
  // Loop through each element and check if it has the 'data-day' attribute
  items.forEach(item => {
    const itemDay = item.getAttribute('data-selectedtitle-day'); // Get the value of the 'data-day' attribute
    
    // If the element's day matches the passed 'day', update the data-category-index
    if (itemDay === day) {
      // Update the 'data-category-index' attribute with the new index
      item.setAttribute('data-tiffin-plan', newIndex);
    }
  });
}


function reversSelectedmainTiffinlayout()
{ 
const collapsible_content_tiffinAll = document.querySelectorAll('.maintiffin-category-prdlists')
const accord_active_tiffinAll = document.querySelectorAll('.main-tiff-type-cat-accord-tittle')
if(collapsible_content_tiffinAll){ 
  collapsible_content_tiffinAll.forEach(collapsible_content_tiffin => {
    collapsible_content_tiffin.classList.remove('hidden')
  });
  }
  if(accord_active_tiffinAll){ 
  accord_active_tiffinAll.forEach(accord_active_tiffin => {
    accord_active_tiffin.classList.add('accord-active')
  });
  }
}



const selectNextTiffinsizeButtonAll = document.querySelectorAll('.tiffin-add-anothertiffin-btn');
if(selectNextTiffinsizeButtonAll)
{ 
    selectNextTiffinsizeButtonAll.forEach(selectNextTiffinsizeButton => {
    selectNextTiffinsizeButton.addEventListener('click',function(e){ 
    const selectedSizePlan = e.target;
    const currentdataplan = selectedSizePlan.getAttribute('data-tiffin-size');
     const currentActiveDay = (getCurrentDay() || '').toLowerCase(); 
    const nextDataplan = parseInt(currentdataplan) + 1;
    const planToAdd = selectNonExistingPlan(currentActiveDay)
    currentTiffinPlan = planToAdd;
     checkCurrentSizePlanValidation(currentTiffinPlan)
    selectedSizePlan.setAttribute('data-tiffin-size',planToAdd)
    updateCategoryIndexForDay(currentActiveDay, currentTiffinPlan);
    reversSelectedmainTiffinlayout()
    scrollToTop()
  })
  });
}



function getCurrentDay(){ 
const activeName =document.querySelector('.tiffin-calendar-day-btn.active-day')?.dataset.dayName;
currentDay = activeName
return activeName
}


function checkCurrentSizePlanValidation(currentTiffinPlan) {
  const currentActiveDay = (getCurrentDay() || '').toLowerCase(); // e.g., "tuesday"
  const requiredCats = new Set(['protein', 'probiotics', 'sides', 'veggies']); // adjust if needed
  const btnall = document.querySelectorAll('.tiffin-add-anothertiffin-btn');
  // guard
  if (!btnall) return false;
  // filter cart by day and plan
  const itemsToday = (Array.isArray(tempCartStore) ? tempCartStore : []).filter(
    i =>
      String(i?.day || '').toLowerCase() === currentActiveDay &&
      Number(i?.tiffintype) === Number(currentTiffinPlan)
  );
  // track which required categories are present
  const present = new Set();
  for (const it of itemsToday) {
    const cat = String(it?.category || '').toLowerCase().trim();
    if (cat === 'probiotic') present.add('probiotics'); // normalize singular
    if (requiredCats.has(cat)) present.add(cat);
  }

  const allGood = [...requiredCats].every(c => present.has(c));
  // toggle button visibility
  btnall.forEach(btn => {
  btn.classList.toggle('hidden', !allGood); 
  });
  return allGood;
}



 function selectNonExistingPlan(day) {
  const requiredCats = ['protein','veggies','probiotics','sides'];
  const clean = v => (v ?? '').toString().trim().toLowerCase();
  const dayKey = clean(day);
  if (!dayKey) return 1;
  // gather categories chosen per plan for this day
  const pickedByPlan = {};
  const items = Array.isArray(tempCartStore) ? tempCartStore : [];
  for (const it of items) {
    if (clean(it?.type) !== 'main') continue;
    if (clean(it?.day) !== dayKey) continue;
    const plan = Number(it?.tiffintype);
    if (!Number.isFinite(plan)) continue;
    pickedByPlan[plan] ??= new Set();
    pickedByPlan[plan].add(clean(it?.category).split(':')[0]);
  }
  const needed = new Set(requiredCats.map(c => clean(c)));
  const isComplete = p => [...needed].every(cat => pickedByPlan[p]?.has(cat));
  // find first existing plan that is not complete
  const existing = Object.keys(pickedByPlan).map(Number).sort((a,b)=>a-b);
  for (const p of existing) {
    if (!isComplete(p)) {
      currentTiffinPlan = p;
      syncMainSelections(p, day);
      return p;
    }
  }
  // all existing complete → choose smallest unused positive integer
  let next = 1;
  while (existing.includes(next)) next++;
  currentTiffinPlan = next;
  syncMainSelections(next, day);
  return next;
}





 function syncMainSelections(plan, day) {
  const clean = v => (v ?? '').toString().trim().toLowerCase();
  const planNum = Number(plan);
  const dayKey = clean(day);
  const selelctedProductitleName = document.querySelectorAll(`.mantiffin-selected-items-title[data-main][data-selectedtitle-day=${dayKey}]`)
  // guard: need a valid plan and day to scope DOM ops
  if (!Number.isFinite(planNum) || !dayKey) return;
  const mainCategoryElement = document.querySelectorAll(
    `.maintiffin-input-label[data-day-days="${dayKey}"]`
  );
  // Detect any matching data for this plan+day (mains only)
  const items = Array.isArray(tempCartStore) ? tempCartStore : [];
  const matches = items.filter(
    it =>
      clean(it?.type) == 'main' &&
      Number(it?.tiffintype) == planNum &&
      clean(it?.day) == dayKey
  );
 if(!soldout_nextweekmenu_enable) { 
  toastr.success(`Switched to Tiffin ${planNum} for ${dayKey}`);
  }
  if(isMobile)
      { 
       document.body.classList.remove('mobile-cart-summary');
        const container = document.querySelector('.cart-summary-container');
       if (container) container.classList.remove('cart-summary-swipe');
    }
  setTimeout(() => {
  updateCategoryIndexForDay(day,planNum)  
  }, 2000);
  // If no data for this plan+day, fully reset UI for that day and exit
  if (matches.length === 0) {
    mainCategoryElement.forEach(mainCategoryEl => {
      selelctedProductitleName.forEach(selectedtitleEl => {
        selectedtitleEl.textContent = ''
      });
      const labelElement = mainCategoryEl.querySelector('.maintiffin-prod-radio-label')
      labelElement.classList.remove('active');
      const inputEl = mainCategoryEl.querySelector('.maintiffin-products-select[data-main-category]');
      if (inputEl) inputEl.checked = false;
    });
    return;
  }
  const tiffindaymainWrapper = document.querySelectorAll('.tiffin-products-daywise-wrapper');
   if (tiffindaymainWrapper) {
    tiffindaymainWrapper.forEach(el => {
    const elDay = el.dataset.daywiseCategory?.toLowerCase();
    if (elDay == dayKey) {
      el.style.display = 'block';
    } else {
      el.style.display = 'none';
    }
   });
  }
const mainButtonElementTop = document.querySelectorAll('.tiffin-calendar-day-btn');
if (mainButtonElementTop) {
  mainButtonElementTop.forEach(el => {
    const elDay = el.dataset.dayName?.toLowerCase();
    if (elDay == dayKey) {
      el.classList.add('active-day');
    } else {
      el.classList.remove('active-day');
    }
  });
}
const mainTiffinSwitchButtons = document.querySelectorAll('.tiffin-type-main-button');
if (mainTiffinSwitchButtons) {
  mainTiffinSwitchButtons.forEach(el => {
    const elDay = el.dataset.dayName?.toLowerCase();
    if (elDay == dayKey) {
      el.click();
    } 
  });
}
  // Build lookup: category -> selected variantID
  const selectedByCat = {};
  for (const it of matches) {
    const cat = clean(it?.category).split(':')[0];
    if (!cat) continue;
    selectedByCat[cat] = String(it?.variantID ?? '');
  }

selelctedProductitleName.forEach(selectedtitleEl => {
  const selectedtitleCategory = clean(selectedtitleEl.getAttribute("data-selectedtitle-name"));
  // Find matching item in `matches` for this category
  const matchedItem = matches.find(it => clean(it?.category).split(':')[0] === selectedtitleCategory);

  if (matchedItem) {
    // Use title or product name as display
    const displayTitle = matchedItem?.title || matchedItem?.productTitle || matchedItem?.name || '';
    const quantity = matchedItem?.quantity ? ` x ${matchedItem.quantity}` : '';
    selectedtitleEl.textContent = displayTitle ? `(${displayTitle}${quantity})` : '';
  } else {
    // Reset if no match
    selectedtitleEl.textContent = '';
  }
});
  // Toggle per rendered label
  mainCategoryElement.forEach(mainCategoryEl => {
    const cat = clean(mainCategoryEl?.dataset?.categoryName);
    const wantVariant = selectedByCat[cat] || ''; 
    const labelElement = mainCategoryEl.querySelector('.maintiffin-prod-radio-label')
    const inputEl = mainCategoryEl.querySelector('.maintiffin-products-select[data-main-category]');
    if (!inputEl) return;

    const variant = String(inputEl.dataset.prodVariant || '');
    const shouldCheck = wantVariant && variant === wantVariant;
    // reset
    inputEl.checked = false;
    labelElement.classList.remove('active');
    // set active only if chosen
    if (shouldCheck && !inputEl.disabled) {
      inputEl.checked = true;
      labelElement.classList.add('active');
    }
  });
  // Ensure groups with no selection are fully reset
  const radios = document.querySelectorAll(
    `.maintiffin-input-label[data-day-days="${dayKey}"] .maintiffin-products-select[data-main-category]`
  );
  const byName = {};
  radios.forEach(r => (byName[r.name] ||= []).push(r));
  Object.values(byName).forEach(group => {
    if (!group.some(r => r.checked)) {
      group.forEach(r => {
        const lbl = r.closest('.maintiffin-prod-radio-label');
        if (lbl) lbl.classList.remove('active');
      });
    }
  });
}




// Add to cart logic starts from here
function maintiffinAddtoCart(input)
{ 
    const currentInput = input;
    let selectedTiffinValueSize = currentTiffinPlan;
    const currentlabel = document.querySelector(`label[for="${currentInput.id}"]`);
		const clicked_product_liwrapper = currentInput.closest(".category-product-detail");
    const related_popup_addtocart = clicked_product_liwrapper.querySelector('.popupaddtocard ')
    const title = clicked_product_liwrapper.querySelector(".tiffin-prod-title").innerText.trim();
    const thresoldpriceEl = clicked_product_liwrapper.querySelector('.product-price-threshold');
    const product_image = currentInput.dataset.prodImg;
    const day = currentInput.dataset.dayName.toLowerCase();
   const price = (parseFloat(currentInput.dataset.prodPrice) / 100).toFixed(2);
    const category = currentInput.dataset.categoryName;
  	const variantID = currentInput.dataset.prodVariant;
		const dayDate = currentInput.dataset.dayDate.toLowerCase();
		const currentYear = new Date().getFullYear();
		const dayDateYear = `${dayDate}/${currentYear}`;
		const extrapice = thresoldpriceEl.getAttribute('data-threshold-diff')
    const selected_tiffin_main_wrapper = currentInput.closest(".tiffin-prods-and-title-wrapper");
    const wrappertitle = selected_tiffin_main_wrapper.querySelector(".mantiffin-selected-items-title");
		const selecteItemmsg = selected_tiffin_main_wrapper.querySelector(".select-item-message");
	const qty = 1;
		const existingIndex = tempCartStore.findIndex(
			(item) =>
			item.day === day &&
      item.tiffintype === selectedTiffinValueSize &&
			item.category === category &&
			item.type === "main"
		);

    	if (existingIndex !== -1) {
			tempCartStore.splice(existingIndex, 1);
		} 
    	tempCartStore.push({
			title,
			qty,
			price,
			category,
			variantID,
      product_image,
			day,
			dayDate,
			dayDateYear,
       tiffintype: selectedTiffinValueSize,
			extraprice: extrapice ? extrapice : 0,
			type:  "main",
		});
     if(related_popup_addtocart) related_popup_addtocart.setAttribute('disabled',true)
		if (wrappertitle) {
				const selectedMains = tempCartStore.filter(
					(item) =>
					item.type === "main" &&
					item.day === day &&
          item.tiffintype === selectedTiffinValueSize &&
					item.category === category
				);

				const combinedMainTitles = selectedMains
					.map((main) => `${main.title} x ${main.qty}`)
					.join(", ");
				wrappertitle.innerHTML = `(${combinedMainTitles})`;
		}
		selecteItemmsg.style.display = 'none'
		const sameCategoryInputs = document.querySelectorAll(`.maintiffin-products-select[data-category-name="${category}"]`);
		sameCategoryInputs.forEach(el => {
		  	const lbl = document.querySelector(`label[for="${el.id}"]`);
         if (lbl) lbl.classList.remove('active');
		   });
    if (currentlabel) currentlabel.classList.add('active');
    // togge category on switch
    const current_category_wrapper = input.closest('.maintiffin-category-prdlists')
    const currentIndex = parseInt(current_category_wrapper.dataset.categoryIndex, 10);
   const upcomingIndex = currentIndex + 1;
   const upcomingmenuwrapperMain = document.querySelector(`.maintiffin-category-prdlists[data-main-tiffinday='${day}'][data-category-index='${upcomingIndex}']`);
   if(upcomingIndex == 5)
   { 
    const addon_collapsible = document.querySelector(`.select-addon-collapsible[data-select-day=${day}]`);
    const addon_wrapper = document.querySelector(`.alacarte-tiff-type-prod-selector[data-products-day=${day}]`)
    if (addon_wrapper) {
 addon_wrapper.style.display = addon_wrapper.style.display === "none" ? "block" : "none";
}
   }
   setTimeout(() => {
       if(upcomingmenuwrapperMain) upcomingmenuwrapperMain.classList.remove('hidden')
   if(current_category_wrapper) current_category_wrapper.classList.add('hidden')
   }, 500);

    updateCartSummary(true)
}




// Add to cart logic starts from here
const addtobuttoninputchange = document.querySelectorAll(".maintiffin-products-select");
addtobuttoninputchange.forEach(input => {
	input.addEventListener("click", function(e) {
    closePopup()
    maintiffinAddtoCart(input)
  })
})


   const addToTiffinButtons = document.querySelectorAll(".addtotiffin-mainbtn");
   addToTiffinButtons.forEach(button => {
       button.addEventListener("click", function(e) {
        closePopup()
           const container = button.closest(".tiffinday-quantity-addtocartbtn");
           const quantitySelectors = container.querySelector(".tiffinday-quantity-selectors");
           const quantity = parseInt(button.getAttribute('data-quantity'), 10);
           const input = quantitySelectors.querySelector("input");
           quantitySelectors.classList.remove("quanityselectortoggle");

           input.value = quantity;
           const selected_tiffin_main_wrapper = e.target.closest( ".alacarte-tiff-type-prod-and-title-wrapper");
           const wrappertitle = selected_tiffin_main_wrapper.querySelector(
               ".alacarte-tiffday-title-selected-items"
           );

           const activeQuantitySelector = document.querySelectorAll('.tiffinday-quantity-addtocartbtn.active-quantity');
           activeQuantitySelector.forEach((item) => {
               const input = item.querySelector('input');
               if (!input) return;
               const inputValue = input.value;

               const quanittySelctor = item.querySelector('.tiffinday-quantity-selectors');

               const mainPlusIcon = item.querySelector('.addtotiffin-mainbtn');
               mainPlusIcon.classList.remove('hidden')
               quanittySelctor.classList.add('hidden')
               if (mainPlusIcon) {
                   mainPlusIcon.innerHTML = inputValue;
                   mainPlusIcon.classList.add('inputvalue')
               }
           });

           quantitySelectors.classList.remove('hidden')
           button.classList.add('hidden')
           container.classList.add('active-quantity')
           const selectorwrapper = e.target.closest('.tiffinday-quantity-addtocartbtn');
           const isAddon = selectorwrapper.classList.contains("addonwrapper");
           const product_image = selectorwrapper.dataset.prodImg;
           const wrapper = selectorwrapper.closest(".alacarte-category-prod-wrapper");
           const category = selectorwrapper.dataset.categoryName;
           const variantID = selectorwrapper.dataset.prodVariant;
           const day = selectorwrapper.dataset.dayName.toLowerCase();
           const dayDate = selectorwrapper.dataset.dayDate.toLowerCase();
           const currentYear = new Date().getFullYear();
           const dayDateYear = `${dayDate}/${currentYear}`;
           const title = wrapper.querySelector( ".alacarte-prod-title").innerText;
           const qtyfield = wrapper.querySelector("input");
           const qty = parseInt(qtyfield.value);
           const price = parseFloat(wrapper.querySelector(".alacarte-prod-price").innerText.replace(/[^0-9.]/g, ""));
           // === ADD or update
           const existingIndex = tempCartStore.findIndex(
               (item) =>
               item.title === title &&
               item.day === day &&
               item.category === category &&
               item.type === 'addon'
           );

           if (existingIndex !== -1) {
               tempCartStore[existingIndex].qty = qty;
           } else {
               tempCartStore.push({
                   title,
                   qty,
                   price,
                   category,
                   variantID,
                   product_image,
                   day,
                   dayDate,
                   dayDateYear,
                   type: isAddon ? "addon" : "main",
               });
           }
           wrapper.classList.add("selected");
           wrapper.setAttribute("data-day", day);
           if (!isAddon) wrapper.setAttribute("data-main-category", category);
           else wrapper.setAttribute("data-addon-category", category);
           const header = document.querySelector(
               `[data-tiffin-cat="${category}"] h3`
           );
           if (header) {
               if (isAddon) {
                   const selectedAddons = tempCartStore.filter(
                       (item) =>
                       item.type === "addon" &&
                       item.day === day &&
                       item.category === category
                   );
                   const combinedAddonTitles = selectedAddons
                       .map((addon) => `${addon.title} x ${addon.qty}`)
                       .join(", ");
                   wrappertitle.innerHTML = `(${combinedAddonTitles})`;
               } 
           }


// const currentmenuwrapper = input.closest('.selected-addon-cat-prod');
// const currenttitleMain = currentmenuwrapper.querySelector('.selected-addon-cat-name ');
// const currentulwrapper = currentmenuwrapper.querySelector('.selected-addons-prdlist');
// const currentIndex = parseInt(currentmenuwrapper.dataset.categoryIndex, 10);
// const upcomingIndex = currentIndex + 1;
// const upcomingmenuwrapperMain = document.querySelector(`.selected-addon-cat-prod[data-day-name='${day}'][data-category-index='${upcomingIndex}']`);

          updateCartSummary(true);
       });
   });



document.addEventListener("click", (e) => {
  const btn = e.target.closest(".minus-quantity-selector.remove-product");
  if (btn) {
    const mainquantitySelector = e.target.closest('.minus-quantity-selector');
    removeItemFromlist(mainquantitySelector);
  }
});




 
  document.addEventListener("click", (e) => {
    // e.preventDefault()
    if (e.target.closest(".tiffin-goto-nextday-btn")) {
      saveGoToBtn = e.target;
      const activeBtn = document.querySelector(".tiffin-calendar-day-btn.active-day");
      if (!activeBtn) return;
      const currentIndex = [...dayButtons].indexOf(activeBtn);
      const currentDayName= activeBtn.getAttribute('data-day-name')
      const nextIndex = currentIndex + 1;
      if (nextIndex < dayButtons.length) {
        const nextBtn = dayButtons[nextIndex];
        nextBtn.click();
        scrollToTop()
        const followingIndex = nextIndex + 1;
        if (followingIndex < dayButtons.length) {
          const followingBtn = dayButtons[followingIndex];
        } else if(followingIndex == 5 ){ 
         const allsavebutton =  document.querySelectorAll('.tiffin-goto-nextday-btn');
         allsavebutton.forEach(element => {
           element.classList.add('hidden')
         });
        }
      }
     updateNavButtons()
          checkCurrentSizePlanValidation(currentTiffinPlan)
    }
  });





 
  // === Quantity Selectors ===
  document.addEventListener("click", (e) => {
    if (
      e.target.classList.contains("plus-quantity-selector-ala") ||
      e.target.classList.contains("minus-quanity-minus")
    ) {
        const mainquanitityWrapper = e.target.closest('.tiffinday-quantity-addtocartbtn');
      const input = mainquanitityWrapper.querySelector(".tiffinday-input-ala");
      let value = parseInt(input.value);
      if (e.target.classList.contains("plus-quantity-selector-ala")) {
        value++;
      } else {
        value = Math.max(1, value - 1);
      }
      const mainPlusbutton = mainquanitityWrapper.querySelector('.addtotiffin-mainbtn')
      mainPlusbutton.setAttribute('data-quantity',value)
      mainquanitityWrapper.classList.add('active-quantity')
      const quantitySelectorWrapper = e.target.closest('.tiffinday-maincategory-quanity-selectors');
      const minusquanity =   quantitySelectorWrapper.querySelector('.minus-quanity-minus');
      const removequantity = quantitySelectorWrapper.querySelector('.minus-quantity-remove');
      const minusQuantityWrapper = quantitySelectorWrapper.querySelector('.minus-quantity-selector-ala');
      if(value == 1)
      { 
      minusQuantityWrapper.classList.add('remove-product')
      removequantity.classList.remove('hidden')
      minusquanity.classList.add('hidden')
      }
      else if (value > 1)
      { 
      minusQuantityWrapper.classList.remove('remove-product')
      minusQuantityWrapper.classList.add('minus-added')
      removequantity.classList.add('hidden')
      minusquanity.classList.remove('hidden')
      mainPlusbutton.classList.remove('inputvalue')
      }
      input.value = value;
       const selected_tiffin_main_wrapper = e.target.closest(".alacarte-tiff-type-prod-and-title-wrapper");
      const wrappertitle = selected_tiffin_main_wrapper.querySelector(".alacarte-tiffday-title-selected-items");

      const selectorwrapper = e.target.closest('.tiffinday-quantity-addtocartbtn');
      const isAddon = selectorwrapper.classList.contains("addonwrapper");
     
      const wrapper = selectorwrapper.closest(".alacarte-category-prod-wrapper");
      const category = selectorwrapper.dataset.categoryName;
      const variantID = selectorwrapper.dataset.prodVariant;
      const day = selectorwrapper.dataset.dayName.toLowerCase();
      const dayDate = selectorwrapper.dataset.dayDate.toLowerCase();
      const currentYear = new Date().getFullYear();
     const dayDateYear = `${dayDate}/${currentYear}`;
     const title = wrapper.querySelector(
        ".alacarte-prod-title"
      ).innerText;
      const qtyfield = wrapper.querySelector(".tiffinday-input-ala");
      const qty = parseInt(qtyfield.value);
      const price = parseFloat(
        wrapper
          .querySelector(".alacarte-prod-price")
          .innerText.replace(/[^0-9.]/g, "")
      );
       // === ADD or update
      const existingIndex = tempCartStore.findIndex(
        (item) =>
          item.title === title &&
          item.day === day &&
          item.category === category &&
          item.type === 'addon'
      );
      if (existingIndex !== -1) {
        tempCartStore[existingIndex].qty = qty;
      } else {
        tempCartStore.push({
          title,
          qty,
          price,
          category,
          variantID,
          day,
          dayDate,
          dayDateYear,
          type: "addon"
        });
      }
      wrapper.classList.add("selected");
      wrapper.setAttribute("data-day", day);
      if (!isAddon) wrapper.setAttribute("data-main-category", category);
      else wrapper.setAttribute("data-addon-category", category);

      const header = document.querySelector(
        `[data-tiffin-cat="${category}"] h3`
      );
  
      if (header) {
        if (isAddon) {
          const selectedAddons = tempCartStore.filter(
            (item) =>
              item.type === "addon" &&
              item.day === day &&
              item.category === category
          );

          const combinedAddonTitles = selectedAddons
            .map((addon) => `${addon.title} x ${addon.qty}`)
            .join(", ");

          wrappertitle.innerHTML = `(${combinedAddonTitles})`;
        } else {
          const selectedMains = tempCartStore.filter(
            (item) =>
              item.type === "main" &&
              item.day === day &&
              item.category === category
          );
          const combinedMainTitles = selectedMains
            .map((main) => `${main.title} x ${main.qty}`)
            .join(", ");

          wrappertitle.innerHTML = `(${combinedMainTitles})`;
        }
      }
      updateCartSummary(true);
    }

  });



  // add class on calender button when products are added
function checkDaysAddButtonClass(){ 
document.querySelectorAll(".tiffin-calendar-day-btn").forEach(btn => {
  const btnDay = btn.dataset.dayName?.trim().toLowerCase();
  if (!btnDay) return;
  const match = tempCartStore.some(item => item.day.toLowerCase() === btnDay);
  if (match) {
    btn.classList.add("product-added");
  } else {
    btn.classList.remove("product-added");
  }
});
}




      




function updateCartSummary(fromCartdrawer,hidecheckout=false) {
  console.log('temp cart store checking',tempCartStore)
  checkCurrentSizePlanValidation(currentTiffinPlan);
  checkDaysAddButtonClass()
  const orderSummaryele = document.querySelector('.order-summary-note-wrapper');
  if(tempCartStore.length > 0)
  { 
    orderSummaryele.classList.remove('hidden')
  } else { orderSummaryele.classList.add('hidden')}
  const dayOrder = ["monday","tuesday","wednesday","thursday","friday"];
  const catOrder = ["protein","veggies","sides","probiotics"];
  const revDays = [...dayOrder].reverse();
  const revCats = [...catOrder].reverse();
  const displayCategoryOrder = ["protein", "veggies", "sides", "probiotics"];
  tempCartStore.sort((a,b)=>{
    const d = revDays.indexOf((a.day||'').toLowerCase()) - revDays.indexOf((b.day||'').toLowerCase());
    if (d) return d;
    if (a.type !== b.type) return a.type === "addon" ? -1 : 1;
    if (a.type === "main" && b.type === "main") {
      const ca = revCats.indexOf((a.category||'').toLowerCase());
      const cb = revCats.indexOf((b.category||'').toLowerCase());
      if (ca === -1 || cb === -1) return cb - ca;
      return ca - cb;
    }
    return 0;
  });
  const summary = document.querySelector(".cart-summary-product-info");
  if(summary)  summary.innerHTML = "";
  let grand = 0;
  let extratotal = 0;
  let anyDayMissing = false;
  const allDays = ["monday","tuesday","wednesday","thursday","friday"];

  allDays.forEach((day)=>{
    const items = tempCartStore.filter(i => (i.day||'').toLowerCase() === day);
    if (!items.length) return;
   const dayDateYear = items[0]?.dayDateYear || "";
   const convertedDayDateYear = formatDayDateYear(dayDateYear)
    const capDay = day[0].toUpperCase()+day.slice(1);
    const mains  = items.filter(i=>i.type==="main");
    const addons = items.filter(i=>i.type==="addon");
    const mainMap  = { protein:[], veggies:[], sides:[], probiotics:[] };
    mains.forEach(i=>{
      const c=(i.category||'').toLowerCase();
      if (!mainMap[c]) mainMap[c]=[];
      mainMap[c].push(i);
    });
    const addonMap = {};
    addons.forEach(i=>{
      const c=i.category||'Other';
      if (!addonMap[c]) addonMap[c]=[];
      addonMap[c].push(i);
    });

    const renderGroup = (label, groups) => {
      if (label === "Main") {
        const mainGroups = {};
        Object.keys(groups).forEach(catKey => {
          (groups[catKey] || []).forEach(item => {
            const tt = String(item.tiffintype ?? "").trim() || "1";
            const cat = (item.category || "").toLowerCase();
            if (!mainGroups[tt]) mainGroups[tt] = {};
            if (!mainGroups[tt][cat]) mainGroups[tt][cat] = [];
            mainGroups[tt][cat].push({ ...item });
          });
        });

        const ttKeys = Object.keys(mainGroups).sort((a, b) => {
          const na = +a, nb = +b;
          if (!Number.isNaN(na) && !Number.isNaN(nb)) return na - nb;
          if (!Number.isNaN(na)) return -1;
          if (!Number.isNaN(nb)) return 1;
          return a.localeCompare(b);
        });

        let html = "";
        let totalAll = 0;
        let extraAll = 0;
        let anyMissing = false;

        ttKeys.forEach(tt => {
         html += `<div class="addons-section main-section">
    <span class="extra-addon-tags tiffin-prices">
      Tiffin ${tt} 
      <span class='tiffin-price-header' data-tt="${tt}"></span>
    </span>`;
          let subtotal = 0;
          let extraprice = 0;
          displayCategoryOrder.forEach(catKey => {
            const list = mainGroups[tt][catKey];
            if (!list || !list.length) return;

            const fromCartFlag = list.some(item => item.fromCart);
            const agg = {};

            list.forEach(({ title, qty=1, price=0, extraPrice=0, extraprice:ep=0, cartLine=null,product_image=null,fromCart }) => {
              const k = String(title);
              if (!agg[k]) agg[k] = { title, qty: 0, price, extraPrice: 0, cartLine,product_image,fromCart };
              agg[k].qty += qty;

              const th   = window.priceThresholds?.[catKey] || 0;
              const over = Math.max(0, (parseFloat(price)||0) - th);
              const ex   = parseFloat(extraPrice || ep || 0);
              const add  = ex > 0 ? ex : over;

              agg[k].extraPrice += add * qty;
            });

            html += `<div class="addon-tiffin-added-product tiffin-added-product">
              <div class="added-addonlist-wrapper">`;

            Object.values(agg).forEach(({ title, qty, price, extraPrice, cartLine,product_image,fromCart}) => {
              subtotal += qty * price;
              extraprice += extraPrice;
              html += `<span class="added-addon-main-wrapper">
               
              <div class='cartsummary-added-prod-wrapper-img'>
                <div class="cartsummary-prod-img">
              <span class="added-category">${catKey}</span>
                 <div class='added-category-img'>
                <img
                decoding="async"
                class="lazyloadt4s"
                 src='${product_image ? product_image : "https://cdn.shopify.com/s/files/1/0772/7094/1938/files/LOGO_4f134c1a-e5ee-4c60-9ca7-85863850344d.png?v=1753781305"}'
                  loading='lazy' alt="Product Image" />
                </div>
                </div>
                <div class='added-category-wrapper-titles'>
                <span class="added-category-wrapper addonriceo">${title} ${extraPrice > 0 ? `+ ($${extraPrice.toFixed(2)})` : ""} </span>
                </div>
                </div>
                <button class="remove-btn healthy-tiffin-button"
                  data-day="${day}"
                  data-main="true"
                  data-item-cartline="${cartLine}"
                  data-tiffintype="${tt}"
                  data-cat="${catKey}"
                  data-title="${title}"
                  data-quantity="${qty}">
                  </button>
              </span>`;
            });

            html += `</div></div>`;
          });

          const result = getMissingCategoriesForDay({
            day: day.toLowerCase(),
            tempCartStore,
            CartupdateReviewIntial,
            tt
          });

          if (result.missing.length) {
            anyMissing = true;
            const cap = s => s.charAt(0).toUpperCase() + s.slice(1);
            const capDay = day.charAt(0).toUpperCase() + day.slice(1);
            html += `<p class="day-missing-main missingdaysnoticeadd notice" data-day-name=${capDay} data-tiffin-size=${result.tiffinSize}>
              Please click here to add <span class="missing-cat">${result.missing.map(cap).join(", ")}</span>
              from tiffin <span class="missing-tt">${result.tiffinSize}</span> for ${capDay}.
            </p>`;
          }

          const shown = subtotal - extraprice;
          if (!result.missing.length) {
               html = html.replace(
              new RegExp(`<span class='tiffin-price-header' data-tt="${tt}"></span>`),
               `<span class='tiffin-price-header' data-tt="${tt}">
                 - $${shown.toFixed(2)}${extraprice ? ` + ($${extraprice.toFixed(2)})` : ""}
                 </span>`
               )}
   
          totalAll += subtotal;
          extraAll += extraprice;
        });
        return { html, total: totalAll, extraprice: extraAll, isMissing: anyMissing };
      }

      const nonEmptyCats = Object.values(groups).filter(arr => Array.isArray(arr) && arr.length > 0);
      if (nonEmptyCats.length === 0) return { html: "", total: 0, extraprice: 0, isMissing: false };

      let h = `<div class="addons-section"><span class="extra-addon-tags">A La Carte</span>`;
      let subtotal = 0;
      let extraprice = 0;

      Object.keys(groups).forEach(cat => {
        const list = groups[cat];
        if (!list || !list.length) return;

        const fromCartFlag = list.some(item => item.fromCart);
        const agg = {};
        list.forEach(({ title, qty = 1, price = 0, extraprice: ep = 0, extraPrice = 0, cartLine=null,product_image,fromCart }) => {
          const k = String(title);
          if (!agg[k]) agg[k] = { title, qty: 0, price, extraPrice: 0, cartLine,product_image,fromCart};
          agg[k].qty += qty;
          agg[k].extraPrice += parseFloat(extraPrice || ep || 0);
        });

        h += `<div class="addon-tiffin-added-product ala-added-proudct-main-wrapper tiffin-added-product">
          <span class="added-category added-category-ala">${cat}</span>
          <div class="added-addonlist-wrapper">`;

        Object.values(agg).forEach(({ title, qty, price, extraPrice, cartLine,product_image,fromCart }) => {
          subtotal += qty * price;
          extraprice += extraPrice;
          const formattedPrice =
  Number(price).toFixed(2) !== String(price)
    ? Number(price).toFixed(2)
    : price;
          h += `<div class=" added-addon-main-wrapper">
          <div class='addon-image-title-wrap'>
          <div class='cartsummary-added-prod-wrapper-img'>
             <img
                decoding="async"
                class="lazyloadt4s"
                 src='${product_image ? product_image : "https://cdn.shopify.com/s/files/1/0772/7094/1938/files/LOGO_4f134c1a-e5ee-4c60-9ca7-85863850344d.png?v=1753781305"}'
                  loading='lazy' alt="Product Image" />
                 
              </div>
              <div class='added-category-wrapper-titles'>
            <span class="added-category-wrapper addded-addon-cat-prod-title addonrice">${title} </span>
            <span class='added-addon-cat-prod-price'> ${price > 0 ? ` ($${formattedPrice}) x ${qty}` : ""}  </span>
            </div>
            </div>
            <button class="remove-btn healthy-tiffin-button"
              data-day="${day}"
              data-addon="true"
              data-item-cartline="${cartLine}"
              data-cat="${cat}"
              data-title="${title}"
              data-quantity="${qty}">
              </button>
          </div>`;
        });

        h += `</div></div>`;
      });
      return { html: h, total: subtotal, extraprice };
    };
    const mainRes  = renderGroup("Main", mainMap);
    const addonRes = renderGroup("A La Carte", addonMap);
    const extraPriceForDay = (mainRes && mainRes.extraprice) ? mainRes.extraprice : 0;
    const daytotalextrapriceMinused =  (mainRes.total || 0) - extraPriceForDay;
    const dayTotal = daytotalextrapriceMinused + (addonRes.total || 0);

    const dayId = `day-${day}`;
    let html = `<div class="day-cart-summary" data-day="${day}">
      <div class="collapse-toggle day-toggle" data-target="#${dayId}"> <span class='day-total-name'>${convertedDayDateYear} | ${capDay} </span>
      <div class='total-price-icon-wrapper'>
      ${!mainRes.isMissing ? `<span class='day-total-header'>$${dayTotal.toFixed(2)}${extraPriceForDay ? ' + ($' + extraPriceForDay.toFixed(2) + ')' : ''}</span>` : ''}
        <div class='collpsible-icon'>
          <span class='collapsible-down'>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.66675 6.66699L8.00008 10.0003L11.3334 6.66699" stroke="#127E51" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span class='collapsible-up hidden'>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.66675 6.66699L8.00008 10.0003L11.3334 6.66699" stroke="#127E51" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </div>
        </div>
      </div>
      <div id="${dayId}" class="collapse-body">`;

    html += mainRes.html + addonRes.html;

    if (!mainRes.isMissing) {
      const dayTotalValue = dayTotal || 0;
      grand += dayTotal;
      extratotal += (mainRes.extraprice || 0);
    } else {
      html += `</div></div>`;
      anyDayMissing = true;
    }
   if(summary) summary.innerHTML += html;
  });
const mobilepriceheader = document.querySelector('.mobile-header-price');
if (mobilepriceheader) {
  if (!anyDayMissing) {
    const formattedPrice = `$${grand.toFixed(2)}${extratotal > 0 ? ' + ($' + extratotal.toFixed(2) + ')' : ''}`;
    mobilepriceheader.textContent = '';
    if(grand > 0) { 
    mobilepriceheader.textContent = formattedPrice;
    }
  } else {
    mobilepriceheader.textContent = '';  
  }
 }

  const grandEltotalinfo = document.querySelector(".cart-summary-total-info");
  const grandelCheckoutbtn = document.querySelector('.cart-summary-checkout-btn');
  const cart_summary_bottom_info = document.querySelector('.cart-summary-bottom-info')
  const noproductmsginfo = document.querySelector('.no-product-msg-info');
      if(cart_summary_bottom_info) cart_summary_bottom_info.classList.remove('no-products')

  if(grandEltotalinfo)  grandEltotalinfo.dataset.total = grand.toFixed(2);
  let grandtotalhtml;
  if (anyDayMissing) {
    if (noproductmsginfo) {
    noproductmsginfo.innerHTML = ``;
  }
    grandtotalhtml = `<div class='total-price-info'>Total: <span class='tiffin-price'>Please Select Missing Item</span></div>`;
  } else if (grand > 0) {
    if (noproductmsginfo) {
    noproductmsginfo.innerHTML = ``;
  }
    grandtotalhtml = `<div class='total-price-info'>Total: <span class='tiffin-price'>$${grand.toFixed(2)}${extratotal > 0 ? ' + ($' + extratotal.toFixed(2) + ')' : ''}</span></div>`;
  } else {
    if(cart_summary_bottom_info) cart_summary_bottom_info.classList.add('no-products')
     if (noproductmsginfo) {
    noproductmsginfo.innerHTML = `<p>Please add meals to your tiffin.</p>`;
  }
  }

 if(grandEltotalinfo && grandtotalhtml) { 
 grandEltotalinfo.innerHTML = `${grandtotalhtml}`;
 }
 if(grandelCheckoutbtn){ 
  grandelCheckoutbtn.innerHTML=`<div class='loader-buttons-wrapper'>
          <button class="tiffin-add-to-cart healthy-tiffin-button button tiffin-btn cart-summary-addtocart cart-summary-addtocart-mobile ${tempCartStore.length > 0 ? '' : 'hidden'} " ${fromCartdrawer ? 'disabled' : ''}> ${fromCartdrawer ? 'Processing...' : 'Place an Order'}</button>
      <div class="loading-tiffin-checkout hidden"></div>
    </div>`
 }

  if(grandelCheckoutbtn){ 
    const checkoutBtn = grandelCheckoutbtn.querySelector(".tiffin-add-to-cart");
  cardUpdatereview(checkoutBtn, fromCartdrawer);
  } else { 
      const checkoutBtnMain = document.querySelector(".t4s-btn__checkout_button");
  cardUpdatereview(checkoutBtnMain, fromCartdrawer);
  }
}
// updateCartsumamry function ends here


// one listener for all collapses
document.addEventListener('click', (e)=>{
  const btn = e.target.closest('.collapse-toggle');
  if (!btn) return;

  const sel  = btn.getAttribute('data-target');
  const body = document.querySelector(sel);
  if (!body) return;

  const isOpen = body.classList.toggle('hidden') === true; 
  btn.setAttribute('aria-expanded', isOpen);

  const iconDown = btn.querySelector('.collapsible-down');
  const iconUp   = btn.querySelector('.collapsible-up');
  if (iconDown && iconUp) {
    iconDown.classList.toggle('hidden', isOpen); 
    iconUp.classList.toggle('hidden', !isOpen);  
  }
});




function formatDayDateYear(dateStr) {
  const [month, day, year] = dateStr.split("/").map(v => parseInt(v, 10));
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric"
  }).replace(" ", " ").replace(",", "");
}



const REQUIRED_CATEGORIES = ['veggies','sides','protein','probiotics'];
function getMissingCategoriesForDay({
  day,
  tempCartStore,
  CartupdateReviewIntial, // kept for signature compatibility
  tt,
  requiredCategories = ["protein", "veggies", "sides", "probiotics"]
}) {
  const d = String(day || "").toLowerCase();
  const size = tt;

  // main items for the day and tiffinSize
  const mains = (tempCartStore || []).filter(
    i =>
      String(i.day).toLowerCase() === d &&
      String(i.type).toLowerCase() === "main" &&
      (size === undefined || i.tiffintype == size)
  );
  // group by tiffintype
  const byTiffinType = {};
  for (const item of mains) {
    const tt = item.tiffintype ?? "unknown";
    if (!byTiffinType[tt]) byTiffinType[tt] = { present: new Set(), missing: [] };
    byTiffinType[tt].present.add(String(item.category || "").toLowerCase());
  }


  // compute missing per tiffin type
  for (const tt of Object.keys(byTiffinType)) {
    const present = byTiffinType[tt].present;
    byTiffinType[tt].missing = requiredCategories.filter(c => !present.has(c));
  }

  const unionMissing = Array.from(
    new Set(Object.values(byTiffinType).flatMap(g => g.missing))
  );

  const missingTiffinTypes = Object.entries(byTiffinType)
    .filter(([, g]) => g.missing.length > 0)
    .map(([tt]) => tt);

  return {
    day: d,
    tiffinSize: size,
    missing: unionMissing,          // missing categories for this size
    missingTiffinTypes,             // which tiffin types (here usually just size) missing
    byTiffinType
  };
}



function cardUpdatereview(btn, fromCartdrawer,hidecheckout) {
  checkDailyMinimumPrice(tempCartStore).then(({
    valid,
    failures = [],
    addonTotals = {},
    totalsByDay = {}
  }) => {
    const cap = s => s ? s[0].toUpperCase() + s.slice(1) : s;
    const mainCheckoutButton = document.querySelector('.t4s-btn__checkout_button');
    const loading_bar = document.querySelector('.loading-tiffin-checkout');


    if (tempCartStore.length == 0 && btn) { 
      btn.classList.add('hidden');
      btn.setAttribute('disabled', true);
      if (loading_bar) loading_bar.classList.add('hidden');
      return;
    }

    // days where combined total < 29
    const totalUnderDays = Object.entries(totalsByDay)
      .filter(([, v]) => Number(v?.total || 0) < 29)
      .map(([day]) => day);

    // addon-under days that also have combined < 29
    const addonUnderDays = Object.entries(addonTotals)
      .filter(([day, total]) => {
        const t = Number(total || 0);
        // Ensure that totalsByDay[day]?.total is a valid number and not undefined
        const combined = Number(totalsByDay[day]?.total || 0);
        return t >= 0 && t < 29 && combined >= 0 && combined < 29;
      })
      .map(([day]) => day);


    // missing mains by day+plan -> "Tuesday P2"
    const missingByDP = (() => {
      const byDay = failures
        .filter(f => Array.isArray(f.missingCategories) && f.missingCategories.length > 0)
        .reduce((acc, f) => {
          const day = String(f.day || '').toLowerCase();
          const num = String(f.plan || '').replace(/\D+/g, ''); // keep only digits
          if (!acc[day]) acc[day] = new Set();
          if (num) acc[day].add(num);
          return acc;
        }, {});
      return Object.entries(byDay).map(([day, nums]) => {
        const list = [...nums].sort((a, b) => a - b).map(n => `tiffin${n}`).join(', ');
        return `${cap(day)} ${list}`;
      });
    })();

    if (tempCartStore.length < 1) {
      CartupdateReviewIntial = failures;
    }

    const invalid = !valid || totalUnderDays.length > 0 || addonUnderDays.length > 0;

    if (invalid) {
      if (btn) { 
        btn.setAttribute('disabled', true);
        btn.classList.add("disabled");
      }

      if (mainCheckoutButton && fromCartdrawer) { 
        mainCheckoutButton.setAttribute('disabled', true);
        mainCheckoutButton.classList.add("disabled");
      }

      // Set button text based on the issues
      if (missingByDP.length) {
        const message = `Main meal missing for ${missingByDP.join(', ')}`;
        if (btn) btn.textContent = message;
        if (mainCheckoutButton && fromCartdrawer) mainCheckoutButton.textContent = message;
      } else if (totalUnderDays.length) {
        const message = `Daily total < $29 for ${totalUnderDays.map(cap).join(', ')}`;
        if (btn) btn.textContent = message;
        if (mainCheckoutButton && fromCartdrawer) mainCheckoutButton.textContent = message;
      } else if (addonUnderDays.length) {
        const message = `À La Carte minimum $29 for ${addonUnderDays.map(cap).join(', ')}`;
        if (btn) btn.textContent = message;
        if (mainCheckoutButton && fromCartdrawer) mainCheckoutButton.textContent = message;
      } else {
        const message = "Order invalid";
        if (btn) btn.textContent = message;
        if (mainCheckoutButton && fromCartdrawer) mainCheckoutButton.textContent = message;
      }
    } else {
      if (btn) {
        btn.disabled = false;
        btn.classList.remove("disabled");
        btn.textContent = "Place an Order";
      }

      // if (mainCheckoutButton && fromCartdrawer) { 
      //   mainCheckoutButton.disabled = false;
      //   mainCheckoutButton.classList.remove("disabled");
      //   mainCheckoutButton.textContent = "Checkout";
      // }
    }

    if (loading_bar) loading_bar.classList.add('hidden');
  });
}




function checkDailyMinimumPrice(tempCart = null) {
  return new Promise((resolve, reject) => {
    const REQUIRED = ['probiotics', 'sides', 'protein', 'veggies'];

    const getPropCI = (props, key) => {
      if (!props) return undefined;
      const want = String(key || '').toLowerCase();
      if (Array.isArray(props)) {
        const hit = props.find(p => (p?.name || '').toLowerCase() === want);
        return hit?.value;
      }
      const k = Object.keys(props).find(k => k.toLowerCase() === want);
      return k ? props[k] : undefined;
    };

    const clean = v => (v ?? '').toString().trim().toLowerCase();
    const cleanCategory = v => clean(v).split(':')[0]; // "Veggies: 16oz" -> "veggies"
    const toNum = v => {
      const n = Number.parseFloat(v);
      return Number.isFinite(n) ? n : 0;
    };

    const normalize = (items, isTemp = false) => {
      if (!Array.isArray(items)) return [];
      return items.map((item) => {
        const type = clean(isTemp ? item.type : getPropCI(item.properties, 'Type'));
        const isMain = type === 'main';
        const isAddon = type === 'addon';

        const day = clean(isTemp ? item.day : getPropCI(item.properties, 'Day'));
        if (!day) return null;

        const rawPrice = isTemp
          ? item.price
          : (item.original_price ? item.original_price / 100 : item.price);
        const qty = item.quantity ?? item.qty ?? 1;

        const catRaw = isTemp
          ? (item.category ?? getPropCI(item, 'Category'))
          : (getPropCI(item.properties, 'Category') ?? item.category);
        const catKey0 = cleanCategory(catRaw);
        const catKey = catKey0 === 'probiotic' ? 'probiotics' : catKey0;

        const planRaw = isTemp
          ? (item.tiffintype ?? getPropCI(item, 'tiffintype'))
          : (getPropCI(item.properties, 'tiffintype') ?? item.tiffintype);
        const tiffintype = Number.parseInt(planRaw, 10);
        const plan = Number.isFinite(tiffintype) ? tiffintype : null;

        const lineTotal = toNum(rawPrice) * toNum(qty);

        return { day, plan, isMain, isAddon, catKey, lineTotal };
      }).filter(Boolean);
    };

    const compute = (all) => {
      // per day totals (for addon + combined checks, unchanged)
      const addonTotals = {};
      const mainTotalsDayOnly = {};
      const hasMainDayOnly = {};

      // per day+plan mains
      const hasMainByDP = {};             // key "day|plan" -> true
      const mainTotalsByDP = {};          // mains subtotal per day+plan
      const mainCatsByDP = {};            // Set of categories from mains per day+plan

      all.forEach(({ day, plan, isMain, isAddon, catKey, lineTotal }) => {
        if (!day) return;

        if (isMain) {
          hasMainDayOnly[day] = true;
          mainTotalsDayOnly[day] = (mainTotalsDayOnly[day] || 0) + lineTotal;

          if (plan != null) {
            const key = `${day}|${plan}`;
            hasMainByDP[key] = true;
            mainTotalsByDP[key] = (mainTotalsByDP[key] || 0) + lineTotal;
            if (catKey) (mainCatsByDP[key] ||= new Set()).add(catKey);
          }
        }

        if (isAddon) {
          addonTotals[day] = (addonTotals[day] || 0) + lineTotal;
        }
      });

      // per-day combined totals (unchanged)
      const totalsByDay = {};
      Object.keys(hasMainDayOnly).forEach((day) => {
        const main = mainTotalsDayOnly[day] || 0;
        const addon = addonTotals[day] || 0;
        totalsByDay[day] = {
          mainSubtotal: Number(main.toFixed(2)),
          addonSubtotal: Number(addon.toFixed(2)),
          total: Number((main + addon).toFixed(2)),
        };
      });

      // failures per day+plan
      const failures = [];
      Object.keys(hasMainByDP).forEach((key) => {
        const [day, planStr] = key.split('|');
        const plan = Number(planStr);
        const subtotal = mainTotalsByDP[key] || 0;
        const present = mainCatsByDP[key] || new Set();
        const missing = REQUIRED.filter(c => !present.has(c));
        if (subtotal < 29 || missing.length) {
          failures.push({
            day,
            plan,
            mainSubtotal: Number(subtotal.toFixed(2)),
            addonSubtotal: Number((addonTotals[day] || 0).toFixed(2)),
            total: totalsByDay[day]?.total ?? Number(((subtotal) + (addonTotals[day] || 0)).toFixed(2)),
            missingCategories: missing
          });
        }
      });

      // present categories per day+plan (for UI)
      const presentByDayPlan = {};
      Object.entries(mainCatsByDP).forEach(([key, set]) => {
        const [day, planStr] = key.split('|');
        const plan = Number(planStr);
        (presentByDayPlan[day] ||= {})[plan] = Array.from(set);
      });

      return {
        valid: failures.length === 0,
        failures,                 // entries are per day+plan
        presentByDayPlan,         // { day: { plan: [cats...] } }
        addonTotals,              // per day
        mainTotalsByDP,           // per day+plan
        totalsByDay               // per day combined
      };
    };

    fetch("/cart.js")
      .then(r => r.json())
      .then(cart => {
        const result = compute([
          ...normalize(tempCart || [], true),
        ]);
        resolve(result);
      })
      .catch(reject);
  });
}




  function removeInutValue(item)
{ 
const matchingInput = document.querySelector(
  `.tiffinday-input-ala[data-prod-title="${item.title}"][data-prod-category="${item.category}"][data-prod-id="${item.variantID}"][data-menu="${item.type}"][data-day="${item.day}"]`
);
if(matchingInput)
{ 
  matchingInput.value = 1;
const quanittywrapper = matchingInput.closest('.tiffinday-quantity-addtocartbtn');
const inputValue = quanittywrapper.querySelector('.tiffinday-input-ala');
inputValue.value = 1;
const mainplusicon = quanittywrapper.querySelector('.addtotiffin-mainbtn');
const quantitywrapper = quanittywrapper.querySelector('.tiffinday-quantity-selectors');
   const mainquanitityWrapper = quanittywrapper.closest('.tiffinday-quantity-addtocartbtn');
mainquanitityWrapper.classList.remove('active-quantity');
if(mainplusicon)
{ 
  mainplusicon.classList.remove('hidden')
  mainplusicon.innerHTML = `+`
  mainplusicon.setAttribute('data-quantity',1)
  mainplusicon.classList.remove('inputvalue')
}

if(quantitywrapper)
{ 
  quantitywrapper.classList.add('quanityselectortoggle')
  quantitywrapper.classList.add('hidden')
}

}
}
function hasAllCategories(tempCartForDay, planID) {
    const requiredCategories = ["sides", "veggies", "protein"];
    let categories = tempCartForDay.filter(item => item.tiffinPlan === planID).map(item => item.category);
    return requiredCategories.every(category => categories.includes(category));
}

// Function to update currentTiffinPlan based on deletion and available categories
function updateCurrentTiffinPlanForActiveDay() {
  let planday = currentTiffinPlan
  let activeDayButton = document.querySelector('.tiffin-calendar-day-btn.active-day');
let activeDay = activeDayButton.getAttribute('data-day-name');
    // Filter the items for the active day
    let tempCartForDay = tempCartStore.filter(item => item.day === activeDay);

    // Get a list of active tiffin plans for the active day
    let activeTiffinPlans = [...new Set(tempCartForDay.map(item => item.tiffinPlan))];

    // If currentTiffinPlan is deleted, find the next available plan with all categories
    if (!hasAllCategories(tempCartForDay, planday)) {
        for (let i = 1; i <= Math.max(...activeTiffinPlans); i++) {
            if (activeTiffinPlans.includes(i) && hasAllCategories(tempCartForDay, i)) {
                planday = i;
                break;
            }
        }
    }
    currentTiffinPlan = planday

    return {
        currentTiffinPlan: planday,
        activeTiffinPlans: activeTiffinPlans
    };
}


function removeVariantIdFromCart(line,el) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line, quantity: 0 })
  })
  .then(r => r.json())
  .then(cart => {
       const overlaydivCartSummary = document.querySelector('.cart-summary-wrapper')
    refreshMiniCart(el,false);
    updateCartSummary(true);
    updateCurrentTiffinPlanForActiveDay()
    setTimeout(() => {
     if(overlaydivCartSummary) overlaydivCartSummary.classList.remove('cart-summary-overlay')
      
    },2000);

  });
}


function removeItemFromlist(el)
{ 
 const day = el.dataset.day?.toLowerCase() || '';
  const cat = el.dataset.cat?.toLowerCase() || '';
  const title = el.dataset.title?.toLowerCase() || '';
  const quantity = el.dataset.quantity?.toLowerCase() || '';
  const lineId = el.dataset.itemCartline || ''
  const tiffinType = el.dataset.tiffintype || ''
     const addon = el.dataset.addon
    let selectedItem ;
      if (cat && title && addon !== "true") {
        const index = tempCartStore.findIndex(
          (item) =>
            item.day.toLowerCase() === day &&
            item.category.toLowerCase() === cat &&
            item.title.toLowerCase() === title  &&
            item.tiffintype == tiffinType
        );

        if (index !== -1) {
          const item = tempCartStore[index];
             let day = item.day;

            let tiffinTypeSelcted = item.tiffintype;
            let dayTiffinKey = `${day}_${tiffinTypeSelcted}`;

    let groupedItems = {};
            tempCartStore.forEach(item => {
        let key = `${item.day}_${item.tiffintype}`;
        if (item.type === 'main') {
        if (!groupedItems[key]) {
            groupedItems[key] = [];
        }
        groupedItems[key].push(item);
      }
    });


      // Get the group of items for the clicked item
    let group = groupedItems[dayTiffinKey];

    // Check if the clicked item is the last one in the group
    if (group.length === 1 || group.length === group.filter(item => item.cartLineMerge !== item.cartLineMerge).length) {
        console.log(`The clicked item is  the last one in its group: ${item.title}`);
   const overlaydivCartSummary = document.querySelector('.cart-summary-wrapper')
     if(overlaydivCartSummary) overlaydivCartSummary.classList.add('cart-summary-overlay')
        removeVariantIdFromCart(item.cartLineMerge)
    } else {
        console.log(`The clicked item is NOT the last one in its group: ${item.title}`);
    }


          if (item.qty > 1) {
            item.qty -= quantity; 
             removeInutValue(item)
            if (item.qty == 0) {
              tempCartStore.splice(index, 1);
              removeInutValue(item)
            }
          } else {
            tempCartStore.splice(index, 1); 
             removeInutValue(item)
          }
          selectedItem = item
        }

        const selectedAddons = tempCartStore.filter(
          (item) =>
            item.type === "main" &&
            item.day.toLowerCase() === day &&
            item.category.toLowerCase() === cat && 
            item.tiffintype == tiffinType
        );

        const combinedTitles = selectedAddons
          .map((addon) => `${addon.title} x ${addon.qty}`)
          .join(", ");

     

        // Update selected title display
        let mainTitleElem
        if(selectedItem){ 
         mainTitleElem = document.querySelector(
          `.tiffinday-selected-items-title[data-${selectedItem.type}][data-selectedtitle-day="${day}"][data-selectedtitle-name="${cat}"][data-tiffin-plan='${selectedItem.tiffintype}']`
        );
        }
        if(mainTitleElem) { 
          const maintitle_main_wrapper  = mainTitleElem.closest('.main-tiff-type-prod-and-title-wrapper');
          const maintitle_accordheader = maintitle_main_wrapper.querySelector('.main-tiff-type-cat-accord-tittle');
          const mainproduct_ul = maintitle_main_wrapper.querySelector('.maintiffin-category-prdlists');
          if(maintitle_accordheader) maintitle_accordheader.classList.toggle('accord-active')
             if(mainproduct_ul) mainproduct_ul.classList.toggle('hidden')
          const maintitleheader_wrapper = mainTitleElem.closest('.tiffinday-selected-item-headers')        
        const nomsgheader = maintitleheader_wrapper.querySelector('.select-item-message');
        if(nomsgheader) nomsgheader.style.display = 'block'
         
        }
  
        const mainwrapperliLists = document.querySelectorAll(
          `.category-product-detail[data-main-tiffinday="${day}"][ data-main-category="${cat}"]`
        )
        if(mainwrapperliLists){ 

        mainwrapperliLists.forEach((mainwrapperli)=>{ 
         const radioinput =  mainwrapperli.querySelector('.maintiffin-products-select');
          const lbl = document.querySelector(`label[for="${radioinput.id}"]`);
         radioinput.removeAttribute('disabled');
          radioinput.removeAttribute('checked'); 
          lbl.classList.remove('active')
         radioinput.checked = false; 
        })

        }
        if (mainTitleElem ) {
          if (combinedTitles) {
            mainTitleElem.innerHTML = `(${combinedTitles})`;
          } else {
            mainTitleElem.innerHTML = ""; // clear if no items left
          }
        }
        
      } else if (addon == "true") {
        // Remove addon item
        const index = tempCartStore.findIndex(
          (item) =>
            item.day.toLowerCase() == day && item.title.toLowerCase() == title
        );
        if (index !== -1) { 
          const item = tempCartStore[index];
          tempCartStore.splice(index, 1);
          removeInutValue(item)
        } 

        // Rebuild combined titles for addons of this day
        const selectedAddons = tempCartStore.filter(
          (item) => item.type === "addon" && item.day.toLowerCase() === day &&
            item.category.toLowerCase() === cat 
        );

        const combinedTitles = selectedAddons
          .map((addon) => `${addon.title} x ${addon.qty}`)
          .join(", ");

        const addonTitleElem = document.querySelector(
          `.alacarte-tiffday-title-selected-items[data-addon][data-selectedtitle-day="${day}"][data-selectedtitle-name="${cat}"]`
        );
          const hasFromCarTrue = tempCartStore.some(item => item.type === "addon" && item.day.toLowerCase() === day && item.category.toLowerCase() === cat && item.fromCart === "true");

        if (addonTitleElem  ) {
          if (combinedTitles) {
            addonTitleElem.innerHTML = `(${combinedTitles})`;
          } else {
            addonTitleElem.innerHTML = ""; // clear if no addons left
          }
        }
      }
      updateCartSummary(true);
      updateCurrentTiffinPlanForActiveDay()
      if(tempCartStore.length == 0 || !tempCartStore)
      {
        const checkoutbtn = document.querySelector('.tiffin-add-to-cart');
        if(checkoutbtn)
        {
          checkoutbtn.setAttribute('disabled',true);
        }
      }
}

const nextFrame = () =>
new Promise(r => requestAnimationFrame(() => requestAnimationFrame(r)));



function removeFromCartorTiffin (el){ 
   const lineId = el.dataset.itemCartline || ''
    if(lineId != "null" )
  { 
       const overlaydivCartSummary = document.querySelector('.cart-summary-wrapper')
     if(overlaydivCartSummary) overlaydivCartSummary.classList.add('cart-summary-overlay')
     removeVariantIdFromCart(lineId,el)
  }   else 
  { 
    removeItemFromlist(el)
  }
     
}




 document.addEventListener("click", (e) => {
    if (e.target.closest(".remove-btn")) {
      removeFromCartorTiffin(e.target)
    }
  });




  function updateCartCount() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      // cart.item_count holds the total items
      document.querySelectorAll('.t4s-count-box-custom').forEach(function (icon) {
        icon.textContent = cart.item_count;
      });
    })
    .catch(function (err) {
      console.error('Cart fetch failed', err);
    });
}




  function refreshMiniCart(el,initialRender) {
    fetch("/?sections=mini_cart")
      .then((res) => res.json())
      .then((data) => {
        const cartDrawerEl = document.querySelector("#t4s-mini_cart");

       updateCartCount()

        if (cartDrawerEl && data["mini_cart"]) {
          const bottomCartdrawer = cartDrawerEl.querySelector(
            ".t4s-drawer__wrap"
          );

          // Create a temporary DOM element to parse returned HTML
          const tempContainer = document.createElement("div");
          tempContainer.innerHTML = data["mini_cart"];

          const sectionDiv = tempContainer.querySelector(
            "#shopify-section-mini_cart"
          );
          const bottomcontainertemp = sectionDiv.querySelector(
            ".t4s-drawer__wrap"
          );

          if (sectionDiv) {
            bottomCartdrawer.innerHTML = bottomcontainertemp.innerHTML; // replace inner HTML
          } else {
            console.warn(
              "Returned HTML does not contain expected section div."
            );
          }
        if(!initialRender){ 
           handleCartDataTiffinPlan(true).then(()=>{ 
         removeItemFromlist(el)
        })

        }
       
        } else {
          console.warn(
            "Could not refresh cart drawer: drawer element or section data not found."
          );
        }
      })
      .catch((error) => console.error("Error refreshing cart drawer:", error));
  }

handleCartDataTiffinPlan(false,true)


  function handleCartDataTiffinPlan(doNotRender = false,hidecheckout) {
  return fetch("/cart.js")
    .then(res => res.json())
    .then(cart => {
  const out = [];
  
  const clean = v => (v ?? '').toString().trim();
  const lower = v => clean(v).toLowerCase();

  const fmtPrice = cents => (Number.isFinite(+cents) ? (+cents/100).toFixed(2) : '0.00');

  const splitMD = (mdy) => {
    const s = clean(mdy);
    if (!s) return { md: '', mdy: '' };
    // Expect "M/D/YYYY" or "MM/DD/YYYY"
    const parts = s.split('/');
    if (parts.length >= 3) return { md: `${parts[0]}/${parts[1]}`, mdy: `${parts[0]}/${parts[1]}/${parts[2]}` };
    return { md: s, mdy: s };
  };

       cart.items.forEach((item,idx) => {
    const p = item.properties || {};

    const d = new Date(p.Date);
    const day = d.toLocaleDateString(undefined, { weekday: 'long' }).toLowerCase();
 const dayRaw = p.Day ?? p.day;
  const dayDateRaw = p.DayDate ?? p.dayDate ?? p.DayDateYear ?? p.dayDateYear;

   if (p._components) { 
    const dayDate = `${d.getMonth() + 1}/${d.getDate()}`;
    const dayDateYear = `${dayDate}/${d.getFullYear()}`;

    JSON.parse(p._components).forEach(c => {
      const id = c.productVariantId
        ? c.productVariantId.split('/').pop()
        : null;
          
    const imageUrl = c.image
      ? c.image.startsWith('https') ? c.image : `https:${c.image}`  // Only add https: if it doesn't exist
      : null;

      out.push({
        title: c.title || '',
        qty: 1,
        price: Number(c.priceAmount.amount).toFixed(2),
        category: c.relatedCategory || '',
        variantID: id,
        fromCart: true,
        day,
        cartLineMerge: idx + 1, 
        dayDate,
        dayDateYear,
        product_image:imageUrl,
        tiffintype: Number(p._TiffinPlan),
        extraprice: null,
        type: 'main'
      });
    });
} else { 

  const { md: dayDate, mdy: dayDateYear } = splitMD(dayDateRaw);
  
  out.push({
    title: (item.title),
    qty: Number(item.quantity) || 1,
    price: fmtPrice(item.price ?? item.final_price ?? item.original_price),
    category: lower(p.Category ?? p.category),
    variantID: String(item.variant_id ?? item.id ?? ''),
    day: lower(dayRaw),
    fromCart: true,
    cartLine: idx + 1,          // start index from 1
    dayDate,
    dayDateYear,
    product_image:item.image,
    tiffintype: Number(p.TiffinPlan ?? p.tiffintype ?? 1),
    extraprice: (typeof p.ExtraPrice !== 'undefined'
        ? clean(p.ExtraPrice)
        : (typeof p.extraprice !== 'undefined' ? clean(p.extraprice) : '0')),
    type: lower(p.Type ?? p.type ?? 'main'),
  });

}

  });

      const normalisedCartData = out;


      const keyOf = i =>
        `${(i.day||'').toLowerCase()}|${i.tiffintype}|${(i.category||'').toLowerCase()}|${(i.title||'').toLowerCase()}`;

      // 1) allowlist = items that exist in the normalised cart
      const allow = new Set(normalisedCartData.map(keyOf));

      // 2) drop temp items that came from the cart but are no longer in normalised
      tempCartStore = (tempCartStore || []).filter(i => !i.fromCart || allow.has(keyOf(i)));

      // 3) merge with normalised FIRST so its fields (incl. cartLine) override temp
      const merged = [...normalisedCartData, ...tempCartStore];

      // 4) de-dupe by key (first wins => normalised wins)
      const seen = new Set();
      tempCartStore = merged.filter(i => {
        const k = keyOf(i);
        if (seen.has(k)) return false;
        seen.add(k);
        return true;
      });


      // tempCartStore now has cartLine from normalised and no stale cart items
      if (!doNotRender) {
        const currentActiveDay = (getCurrentDay() || '').toLowerCase();
        selectNonExistingPlan(currentActiveDay);
        updateCartSummary(false,true);
      }
      return nextFrame();
    });
}


 

document.addEventListener('click',function(e){ 
   const el = e.target.closest('.missingdaysnoticeadd'); // matches the <p>
  if (!el) return;
  const dayName = (el.dataset.dayName || '').toLowerCase();
  const tiffinSize = Number(el.dataset.tiffinSize || 0);
  if(tiffinSize == 0)
  { 
     selectNonExistingPlan(dayName)
  } else { 
     syncMainSelections(tiffinSize, dayName, tempCartStore);
     currentTiffinPlan = tiffinSize
  }
   updateCategoryIndexForDay(dayName, currentTiffinPlan);


})




    function checkDaysAndAddProduct(tempCartStore, isSteelpackage, callback) {
    const fallbackItemDel = {
      title: "Nutritious! Ginger Carrot Soup",
      qty: 0,
      price: 12,
      category: "Veggies",
      variantID: 44381587472575,
      day: "friday",
      type: "main",
    };

   
    let combinedItems = [];

    fetch("/cart.js")
      .then((res) => res.json())
      .then((shopifyCart) => {
        const shopifyItems = shopifyCart.items.map((item) => ({
          title: item.title,
          qty: item.quantity,
          price: item.price / 100,
          category: item.properties?.Category,
          variantID: item.variant_id,
          day: item.properties?.Day,
          type: item.properties?.Type,
        }));

        combinedItems = combinedItems.concat(shopifyItems);

        if (Array.isArray(tempCartStore)) {
          const tempItems = tempCartStore.map((item) => ({
            title: item.title,
            qty: item.qty || 1,
            price: item.price,
            category: item.category || item.properties?.Category,
            variantID: item.variantID,
            day: item.day || item.properties?.Day,
            type: item.type || item.properties?.Type,
          }));

          combinedItems = combinedItems.concat(tempItems);
        }

        const uniqueDays = new Set();
        combinedItems.forEach((item) => {
          if (item.day) uniqueDays.add(item.day.toLowerCase());
        });


        uniqueDay = uniqueDays.size;


        if ( uniqueDays.size > 0) {
          // Ensure fallback is added cleanly (remove if exists first)

          // addToCart(fallbackItem, () => {
            setTimeout(callback, 400); 
          // });
        } else {
          // Unique days >= 2 → make sure fallback is removed
          // removeFromCart(fallbackItem, () => {
            setTimeout(callback, 300);
          // });
        }
      })
      .catch((err) => {
        console.error("Error checking cart days:", err);
        callback(); // Proceed even on failure
      });
  }

  document.addEventListener("click", (e) => {
  if (e.target.closest(".tiffin-add-to-cart")) {
    const tiffinbutton = e.target;
    const loadertiffin = document.querySelector(".loading-tiffin-checkout");

    loadertiffin.classList.remove("hidden");
    tiffinbutton.setAttribute("disabled", true);
    showToaster = false
    let steelPackagingSelected = true;

    checkDaysAndAddProduct(tempCartStore, steelPackagingSelected, () => {
      fetch("/cart/clear.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" }
      })
      .then(() => {
//        const addItems = tempCartStore.map((item) => {
//   const isMain = String(item.type).toLowerCase() === "main";

//    const properties = isMain
//     ? {
//         _Day: item.day,
//         Day:item.day,
//         _DayDate: item.dayDateYear,
//         Category: item.category,     
//         _Type: item.type,
//         _TiffinPlan: item.tiffintype,
//         _image:item.product_image,
//       }
//     : {
//         Day: item.day,
//          _Day: item.day,
//         DayDate: item.dayDateYear,
//         Category: item.category,      
//         Type: item.type,
//       };

//   return { id: item.variantID, quantity: item.qty, properties };
// });

const addItems = tempCartStore.map((item) => {
  const isMain = String(item.type).toLowerCase() === "main";

  const properties = isMain
    ? {
        _Day: item.day,
        Day: item.day,
        _DayDate: item.dayDateYear,
        Category: item.category,
        _Type: item.type,
        _TiffinPlan: item.tiffintype,
        _image: item.product_image,
      }
    : {
        Day: item.day,
        _Day: item.day,
        DayDate: item.dayDateYear,
        Category: item.category,
        Type: item.type,
      };

 const hasInvalidValue = Object.entries(properties).some(([key, value]) => {
  // allow null image
  if (key === "_image") return false;

  return (
    value === undefined ||
    value === null ||
    value === "" ||
    value === "undefined"
  );
});

  if (hasInvalidValue) {
    toastr.error("Something went wrong. Refreshing…");

    setTimeout(() => {
      window.location.reload();
    }, 2000);

    throw new Error("Invalid properties data");
  }

  return { id: item.variantID, quantity: item.qty, properties };
});



        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: addItems })
        });
      })
      .then(() => {
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            attributes: { Daycount: uniqueDay },
          })
        });
      })
      .then(res => res.json())
      .then(cartData => {
      if (cartData.item_count) {
    

     tempCartStore = [];

    // wait for re-render, then go
   return handleCartDataTiffinPlan()
  .then(() => updateCartCount ()) 
  .catch(err => console.warn('mini cart refresh failed, proceeding', err)) 
  .then(() => {
    setTimeout(() => {
      if(isMobile)
      { 
       document.body.classList.remove('mobile-cart-summary');
           const container = document.querySelector('.cart-summary-container');
    if (container) container.classList.remove('cart-summary-swipe');
      }
      loadertiffin.classList.add("hidden");
      tiffinbutton.removeAttribute("disabled");
      window.location.assign("/checkout");
    }, 200);
  })
  }
})
      .catch(err => {
        console.error("Cart submission failed", err);
        loadertiffin.classList.add("hidden");
        tiffinbutton.removeAttribute("disabled");
      });
    });
  }
});



const sections = document.querySelectorAll('.tiffin-prods-and-title-wrapper');
const sidebarItems = document.querySelectorAll('.sidebar-cat-name');

function activateSidebar() {
  let activeCat = null;

  sections.forEach(section => {
    const rect = section.getBoundingClientRect();
    if (rect.top <= 100 && rect.bottom > 100) {
      activeCat = section.dataset.tiffinCat;
    }
  });

  // fallback: no section near top
  if (!activeCat && sections.length > 0) {
    activeCat = sections[0].dataset.tiffinCat;
  }

  sidebarItems.forEach(item => {
    if (item.dataset.catName === activeCat) {
      item.classList.add('active');
    } else {
      item.classList.remove('active');
    }
  });
}

const mobileswipeup = document.querySelector('.mobile-cart-swipe');
const cartSummaryDetails = document.querySelector('.cart-summary-container');
const cartSummaryWrapper = document.querySelector('.cart-summary-wrapper');

if (mobileswipeup) {
  mobileswipeup.addEventListener('click', function (e) {
    e.stopPropagation(); // prevent bubbling to document
    const cartSummaryPopup = document.querySelector('.desktop-product-popup-holder');
    document.body.classList.toggle('mobile-cart-summary');
    document.body.classList.remove('popup-description')
     document.body.classList.add('popup-validation');
    cartSummaryDetails.classList.toggle('cart-summary-swipe');
    if (cartSummaryPopup) cartSummaryPopup.style.display = 'none';
  });
}

if(isMobile)
{ 
  const cartsummarytitle = document.querySelector('.cart-summary-title');

  if (cartsummarytitle) {
  cartsummarytitle.addEventListener('click', function (e) {
    e.stopPropagation(); // prevent bubbling to document
    const cartSummaryPopup = document.querySelector('.desktop-product-popup-holder');
    document.body.classList.toggle('mobile-cart-summary');
    document.body.classList.remove('popup-description')
     document.body.classList.add('popup-validation');
    cartSummaryDetails.classList.toggle('cart-summary-swipe');
    if (cartSummaryPopup) cartSummaryPopup.style.display = 'none';
  });
}
}



document.addEventListener('click', function (e) {
  // use composedPath to capture the full ancestry before removal
  const path = e.composedPath ? e.composedPath() : [];
  const insideCart = path.some(el => el.classList && el.classList.contains('cart-summary-wrapper'));
  const isCartOpen = document.body.classList.contains('mobile-cart-summary');
  const fromdescription_popup = document.body.classList.contains('popup-description');

  if(fromdescription_popup)
  { 
        document.body.classList.add('popup-validation');
         document.body.classList.remove('popup-description');

  }
  const testpopupclass = document.body.classList.contains('popup-validation');

  if (isCartOpen && !insideCart ) {
    if(!fromdescription_popup && testpopupclass){
    document.body.classList.remove('mobile-cart-summary');
    const container = document.querySelector('.cart-summary-container');
    const popupcontainer = document.querySelector('.desktop-product-popup-holder')
    const productcartsummary_container = document.querySelector('.cart-summary-popover-info')
    if (container) container.classList.remove('cart-summary-swipe');
    if(popupcontainer) popupcontainer.style.display='none'
        if(productcartsummary_container) productcartsummary_container.style.display='block'

     }
  }
});




if(sidebarItems.length > 0)sidebarItems[0].classList.add('active');
if(!isMobile){ 
  window.addEventListener('scroll', activateSidebar);
activateSidebar();
}


  setTimeout(() => {
       const checkoutBtn = document.querySelector(".t4s-btn__checkout_button");
  if (checkoutBtn) {
    checkoutBtn.setAttribute("disabled", "true");
  }
    cardUpdatereview(checkoutBtn,true,true);
  }, 2000);




    document.addEventListener("click", (e) => {
    if (e.target.closest(".t4s-btn__checkout_button")) {
      // e.preventDefault(); // prevent default action until fallback check is done
      const chekoutfalsebutton = e.target;
      const checkoutButton = document.querySelector(".t4s-btn__checkout");
      const loadertiffinWrapper = checkoutButton.closest('.loader-buttons-wrapper')
      const loadertiffin = loadertiffinWrapper.querySelector('.loading-tiffin')
                     if(loadertiffin) loadertiffin.classList.remove("hidden");


      if (!checkoutButton) {
        console.warn("Checkout button not found.");
        return;
      }
      fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {

          // Example: Accessing specific values
          const discount = cart.attributes?.Discount;
          const packaging = cart.attributes?.Packaging;
                 if(loadertiffin) loadertiffin.classList.add("hidden");

          if (packaging == "steel") {
            checkDaysAndAddProduct(null, true, () => {
              setTimeout(() => {
              if(loadertiffin) loadertiffin.classList.add("hidden");
             checkoutButton.click();
              }, 100);
            });
          } else {
           if(loadertiffin) loadertiffin.classList.add("hidden");
            checkoutButton.click();
          }
          trackCartItemAddition()

        })
        .catch((error) => {
          console.error("Failed to fetch cart attributes:", error);
        });
    }
  });



  new Swiper(".alacarteSwiper", {
  slidesPerView: "4",
  spaceBetween: 12,
  freeMode: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});




 const selectcollapsibleaddonAll = document.querySelectorAll('.select-addon-collapsible');

if (selectcollapsibleaddonAll.length) {
  selectcollapsibleaddonAll.forEach(selectcollapsibleaddon => {
    
    selectcollapsibleaddon.addEventListener("click", () => {
      const day = selectcollapsibleaddon.getAttribute("data-select-day");
      const related_addon = document.querySelector(`.alacarte-tiff-type-prod-selector[data-products-day="${day}"]`);
      if (!related_addon) return;
      selectcollapsibleaddon.classList.toggle("active");
      if (selectcollapsibleaddon.classList.contains("active")) {
        related_addon.style.display = "block";
      } else {
        related_addon.style.display = "none";
      }
    });

  });
}



const order_note = document.querySelector('.cart-note-header');
if(order_note)
{ 
  order_note.addEventListener('click',function(){ 
    const order_note_textarea = document.querySelector('.t4s-cart-note__input_custom');
    if(order_note_textarea) order_note_textarea.classList.toggle('hidden')
  })
}






    document.addEventListener("click", function (e) {
    const tiffinday_category_title = e.target.closest(
      ".tiffin-accord-title"
    );
    if (tiffinday_category_title) {
      const cat_title =
        tiffinday_category_title.getAttribute("data-tiffin-cat");
      const tiffinday_mainwrapper = tiffinday_category_title.closest(
        ".tiffin-prods-and-title-wrapper"
      );
      const productlist = tiffinday_mainwrapper.querySelector(
        `.category-prdlist-wrapper[data-tiffin-cat="${cat_title}"]`
      );
      productlist.classList.toggle("hidden");
      tiffinday_category_title.classList.toggle("accord-active");
    }
  });




 // on tiffin container to add See more below text
  const Bundlecontainer = document.querySelector(".cart-summary-product-info");
  function handleScrollTiffinSummary() {
    const bundleMainContainer = document.querySelector(
      ".cart-summary-popover-info"
    );
    const scrollHeight = Bundlecontainer.scrollHeight;
    const clientHeight = Bundlecontainer.clientHeight;
    const hasScrollbar = scrollHeight > clientHeight;
    const scrollableAmount = scrollHeight - clientHeight;
    const atTop = Bundlecontainer.scrollTop === 0;

    // Check if there is a scrollbar AND the scrollable area is more than 20px
    if (hasScrollbar && atTop && scrollableAmount > 20 && bundleMainContainer) {
      bundleMainContainer.classList.add("scroll_item");
    } else if (hasScrollbar && !atTop) {
      bundleMainContainer.classList.remove("scroll_item");
    } else {
      bundleMainContainer.classList.remove("scroll_item");
    }
  }

  // Initial check
  if(Bundlecontainer)
  {
    Bundlecontainer.addEventListener("scroll", handleScrollTiffinSummary);
  }
  window.addEventListener("resize", handleScrollTiffinSummary);

  


scrollToTop()

updateCartSummary(true,true)

  

});
